// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:39:44.755Z
// Property: Artisan Crossing Apts (ID: 6767906449165585)
// Collections: 30 amenities, 9 floorplans (live), 22 photos, 73 POIs, 5 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165585",
  "property_external_id": "gklslgw",
  "property_zillow_url": "https://www.zillow.com/homedetails/1303-W-Tecumseh-Rd-VQN7QF-Norman-OK-73069/2059820937_zpid/",
  "property_apartments_url": "https://www.apartments.com/artisan-crossing-apts-norman-ok/gklslgw/",
  "property_google_business_url": "https://www.google.com/maps/place/Artisan+Crossing/data=!4m2!3m1!1s0x0:0x78472d5e38609f1b?sa=X&ved=2ahUKEwiDk8bo8bySAxWLEFkFHX82AIsQ_BJ6BAg8EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "artisan-crossing-apts",
  "property_name": "Artisan Crossing Apts",
  "property_website_url": "https://www.caseusa.com/apartments/ok/norman/artisan-crossing-apts/",
  "property_domain": null,
  "property_address": "1303 West Tecumseh Road",
  "property_full_address": "1303 West Tecumseh Road, Norman, OK, 73069",
  "property_address_1": "1303 West Tecumseh Road",
  "property_address_2": null,
  "property_address_city": "Norman",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73069",
  "property_address_country": "US",
  "property_address_county": "Cleveland County",
  "property_neighborhood_address": "Outer Norman",
  "property_address_latitude": "35.2625",
  "property_address_longitude": "-97.4629",
  "property_email": "artisancrossing@caseusa.com",
  "property_phone": "(405) 450-7918",
  "property_call_tracking_phone": "800-615-7736",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Artisan Crossing Apts in Norman, Oklahoma, your dream home awaits! Choose from stylish one and two-bedroom floor plans featuring modern amenities like a resort-style pool, 24-hour fitness center, and dog park. Experience the allure of expansive living spaces and unmatched convenience—your new lifestyle starts here! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Artisan Crossing Apts, where modern living meets comfort in the heart of Norman, Oklahoma. Our vibrant apartment community offers a variety of stunning floor plans, including spacious one and two-bedroom options, perfect for any lifestyle. Embrace a lifestyle of convenience with a suite of unparalleled amenities designed to elevate your living experience. \n\nLavish in our resort-worthy swimming pool, relax in the sundeck and cabana area, or socialize in our clubhouse equipped with a billiard table. For the active individual, our 24-hour fitness center provides you the freedom to work out at your convenience. Pet owners will appreciate our onsite dog park and lush courtyard with pet stations, making it easy to keep your furry friends happy.\n\nYour comfort is our priority, which is why we offer 24-hour emergency maintenance and flexible payment options. Each apartment is thoughtfully designed with expansive 9-foot ceilings, plush wall-to-wall carpeting, and modern finishes such as white subway tile backsplashes, espresso or dove gray cabinets, and preinstalled WiFi powered by Cox. Several units feature private balconies or patios, perfect for enjoying a morning coffee or evening sunset.\n\nWith secure package receiving, gated electronic access, and onsite management, you can feel at ease in our close-knit community. Browse our available floor plans and discover the lifestyle you’ve always wanted. Find your new home today—schedule a tour or explore our listings at Artisan Crossing Apts!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb38-90db-717d-9484-83d9a4b44b05.webp",
  "property_featured_image_media": {
    "alt_text": "Artisan Crossing apartment complex monument sign and exterior buildings.",
    "public_id": "019cfb38-90db-717d-9484-83d9a4b44b05",
    "storage_key": "property/6767906449165585/019cfb38-90db-717d-9484-83d9a4b44b05.webp",
    "width": 3072,
    "height": 2458
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "246",
  "property_year_built": "2021",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.3739837398374",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "225-325",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum of two pets per unit. Breed restrictions apply.",
  "property_pet_policy_description": "No weight limit for cats or dogs. Maximum of two pets per unit. Breed restrictions apply. One-time non‑refundable pet fee: $500 per pet. Monthly pet rent: $30 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://artisancrossingapartmentsnorman.securecafe.com/onlineleasing/artisan-crossing-apts/floorplans.aspx",
  "property_resident_portal_url": "https://artisancrossingapartmentsnorman.securecafe.com/residentservices/artisan-crossing-apts/userlogin.aspx",
  "property_apply_now_url": "https://artisancrossingapartmentsnorman.securecafe.com/onlineleasing/artisan-crossing-apts/register.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-1f7f-700c-a827-b3538007b51a.webp",
  "property_primary_logo_media": {
    "alt_text": "Artisan Crossing logo",
    "public_id": "019cfb39-1f7f-700c-a827-b3538007b51a",
    "storage_key": "property/6767906449165585/019cfb39-1f7f-700c-a827-b3538007b51a.webp",
    "width": 300,
    "height": 195
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb3a-5066-70c6-8a11-f91addfee3bc.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb3a-5066-70c6-8a11-f91addfee3bc",
    "storage_key": "property/6767906449165585/019cfb3a-5066-70c6-8a11-f91addfee3bc.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb3a-7552-7118-bc79-12abd1c43b97.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Artisan Crossing logo",
    "public_id": "019cfb3a-7552-7118-bc79-12abd1c43b97",
    "storage_key": "property/6767906449165585/019cfb3a-7552-7118-bc79-12abd1c43b97.webp",
    "width": 300,
    "height": 195
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb3a-8120-74a4-a09b-333bc6abdb89.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Artisan Crossing logo",
    "public_id": "019cfb3a-8120-74a4-a09b-333bc6abdb89",
    "storage_key": "property/6767906449165585/019cfb3a-8120-74a4-a09b-333bc6abdb89.webp",
    "width": 300,
    "height": 195
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#324d58",
  "property_secondary_color": "#cac4b8",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 1",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "1",
  "property_bathrooms_range": "1 - 1.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1.5",
  "property_sqft_range": "789 - 1125",
  "property_sqft_min": "789",
  "property_sqft_max": "1125",
  "property_price_range": "1359 - 1719",
  "property_price_min": "1359",
  "property_price_max": "1719",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/ArtisanCrossing/photos/welcome-to-artisan-crossing-where-youll-discover-the-modern-and-convenient-norma/130398222659570/",
  "property_instagram_url": "https://www.instagram.com/artisancrossing/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJcThG21hrsocRG59gOF4tR3g",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/artisan-crossing-norman",
  "property_tiktok_url": "https://www.tiktok.com/@artisancrossingcase",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Artisan Crossing Apts",
  "property_home_romance_title": "Create Cherished Memories in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Artisan Crossing Apts in Norman, Oklahoma, where modern living meets comfort. Choose from spacious one- and two-bedroom floor plans while enjoying a resort-worthy swimming pool, an onsite dog park, and a vibrant clubhouse. Elevate your lifestyle with our upscale amenities tailored for every resident's needs!",
  "property_home_floorplans_blurb": "At Artisan Crossing Apts in Norman, Oklahoma, elevate your living experience with our thoughtfully designed one and two-bedroom floor plans. Each apartment offers modern features and a welcoming ambiance. Browse our available homes and find the perfect space that suits your lifestyle and aspirations today!",
  "property_home_gallery_blurb": "At Artisan Crossing Apts in Norman, Oklahoma, luxurious living meets convenience. Choose from spacious one or two-bedroom floor plans featuring modern amenities like a resort-style pool, 24-hour fitness center, and an onsite dog park. With lush courtyards and stylish interiors, picture yourself thriving in this vibrant community!",
  "property_home_neighborhood_blurb": "At Artisan Crossing Apts in Norman, Oklahoma, your vibrant lifestyle awaits. Nestled amid parks, libraries, and the University of Oklahoma, enjoy easy access to recreational gems like Sutton Wilderness Trail Park and the lively Urban Air Adventure Park. Immerse yourself in community culture—your new home is just the beginning!",
  "property_home_reviews_blurb": "At Artisan Crossing Apartments in Norman, Oklahoma, our residents thrive in a welcoming environment. Enjoy well-maintained spaces, prompt maintenance, and a friendly management team dedicated to making your living experience exceptional. As one resident says, \"This place stays well maintained... and the managers are professional and easy to contact.\" Join our vibrant community today!",
  "property_neighborhood_blurb": "Nestled in the heart of Norman, Artisan Crossing Apts offers not just stylish one- and two-bedroom floor plans, but a vibrant neighborhood teeming with unique experiences. With nearby gems like the Sam Noble Museum, Lloyd Noble Center, and lush parks, immerse yourself in a thriving community where culture and convenience flourish.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Artisan Crossing Apts in Norman, Oklahoma, your lifestyle is enhanced by our resort-style amenities and modern apartment features. Enjoy sunny days at the pool, unwind in our lush courtyard, or challenge friends to a game in the clubhouse. Comfort and style are waiting—step into your new home today!",
  "property_applynow_blurb": "At Artisan Crossing Apts in Norman, Oklahoma, your ideal home awaits! Choose from spacious one or two-bedroom floor plans, complete with modern amenities like a resort-style pool, onsite dog park, and a 24-hour fitness center. Embrace a lifestyle of comfort and convenience—apply online today and make it yours!",
  "property_contactus_blurb": "At Artisan Crossing Apts in Norman, Oklahoma, choose from stylish one and two-bedroom floor plans designed for modern living. Experience the perfect blend of comfort and convenience in a vibrant community. Have questions? Our leasing team is ready to assist—reach out today for personalized support!",
  "property_faqs_blurb": "At Artisan Crossing Apartments in Norman, Oklahoma, we cater to a variety of lifestyles with inviting one- and two-bedroom floor plans. Curious about our community? Our FAQs page provides insightful answers to help you navigate your future home. Start your journey toward comfortable living today!",
  "property_floorplans_blurb": "At Artisan Crossing Apts in Norman, Oklahoma, your dream apartment awaits. Choose from stylish one and two-bedroom layouts designed for comfort and convenience. Each space invites you to personalize it and make it your own. Browse our available apartment homes today and unveil the perfect floor plan just for you!",
  "property_gallery_blurb": "At Artisan Crossing Apts in Norman, Oklahoma, vibrant living meets modern luxury. Imagine soaking in the sun by our resort-worthy pool or playing with your pup at the onsite dog park. With contemporary floor plans, stylish interiors, and a wealth of amenities, your dream lifestyle is just a picture away!",
  "property_interactivemap_blurb": "At Artisan Crossing Apts in Norman, Oklahoma, choose from stylish one and two-bedroom layouts that blend comfort with modern design. With amenities like a resort-worthy pool, onsite dog park, and a vibrant clubhouse, you'll relish every moment. Use our interactive community map to find your ideal home today!",
  "property_pets_blurb": "At Artisan Crossing Apts in Norman, OK, your furry friends are part of the family! With no weight limit and room for two pets, our community embraces your pets (with a few breed restrictions). Enjoy stylish living with parks nearby, fostering a vibrant lifestyle for you and your companions.",
  "property_referafriend_blurb": "At Artisan Crossing Apts in Norman, Oklahoma, vibrant living awaits! Choose from spacious one- and two-bedroom floor plans designed for comfort and style. Best of all, great friends make great neighbors—refer a friend and enhance your community experience today! Share the joy of exceptional living!",
  "property_residentaccess_blurb": "Welcome to Artisan Crossing Apts in Norman, Oklahoma, where comfort meets convenience! With spacious one and two-bedroom floor plans tailored to your lifestyle, our community ensures a seamless living experience. Access your resident portal today to pay rent, schedule maintenance, and stay connected. Your home awaits!",
  "property_reviews_blurb": "At Artisan Crossing Apts in Norman, Oklahoma, residents rave about the professional, friendly management and immaculate property maintenance. One satisfied tenant shared, \"I’ve never had a negative experience… they are on top of things.\" Join a community where pleasant living experiences are the norm! See what our residents have to say!",
  "property_created_at": "1753982377593",
  "property_scheduletour_blurb": "At Artisan Crossing Apts in Norman, Oklahoma, experience the perfect blend of comfort with our inviting one and two-bedroom floor plans. Our vibrant community awaits to welcome you home. Curious about resident experiences? Schedule a tour today and envision your new lifestyle with us!",
  "property_thankyou_blurb": "Thank you for reaching out to Artisan Crossing Apts in Norman, Oklahoma! We take pride in our thoughtfully designed one- and two-bedroom floor plans that cater to your lifestyle. Our team will be in touch soon to help you find your ideal living space amidst our vibrant community!",
  "property_virtualtours_blurb": "Experience modern living at Artisan Crossing Apts in Norman, Oklahoma, where thoughtfully designed one- and two-bedroom floor plans await. Take a virtual tour to immerse yourself in our vibrant community and see why your next home should be here. Your new lifestyle starts with a click!",
  "property_copyright": "2025 All Rights Reserved. Artisan Crossing Apts",
  "property_seo_title_home": "Artisan Crossing Apts |  Apartments in Norman, Oklahoma",
  "property_seo_description_home": "Discover luxury at Artisan Crossing Apts in Norman, OK. Enjoy spacious layouts, a resort-style pool, and an onsite dog park. Find your home today!",
  "property_seo_title_floorplans": "Floor Plans | Norman, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Artisan Crossing Apts in Norman, OK. Choose from stylish one or two-bedroom floor plans that suit your lifestyle. Browse today!",
  "property_seo_title_amenities": "Amenities | Norman, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Artisan Crossing Apts in Norman, OK! Enjoy a resort-style pool, dog park, fitness center & more—your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Norman, Oklahoma",
  "property_seo_description_gallery": "Discover modern living at Artisan Crossing Apts in Norman, OK. Enjoy spacious layouts, luxurious amenities, and a stunning pool. Your perfect home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Artisan Crossing Apts Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Artisan Crossing Apts in Norman, OK. Take a virtual tour and envision your new life in our stylish one and two-bedroom homes!",
  "property_seo_title_interactivemap": "Interactive Map | Artisan Crossing Apts Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Artisan Crossing Apts in Norman, OK! Use our interactive map to explore spacious layouts, top-notch amenities, and available prices.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Norman, Oklahoma",
  "property_seo_description_neighborhood": "Experience the vibrant charm of Norman at Artisan Crossing Apts. Discover local gems and hotspots just steps from your doorstep—your adventure awaits!",
  "property_seo_title_contact": "Contact Us | Artisan Crossing Apts",
  "property_seo_description_contact": "Discover Artisan Crossing Apts in Norman, OK! Our leasing team is here to help you find your ideal one- or two-bedroom home. Contact us today!",
  "property_seo_title_faqs": "FAQs | Apartments in Norman, Oklahoma",
  "property_seo_description_faqs": "Find answers to your queries at Artisan Crossing Apts in Norman! Explore FAQs about our luxury amenities, floor plans, and effortless living today.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Norman, Oklahoma",
  "property_seo_description_reviews": "Discover Artisan Crossing Apts in Norman, OK: a pet-friendly community with modern amenities and a vibrant lifestyle. See what residents love!",
  "property_seo_title_applynow": "Apply Now | Apartments in Norman, Oklahoma",
  "property_seo_description_applynow": "Discover modern living at Artisan Crossing Apts in Norman, OK. Enjoy spacious interiors, resort-style amenities, and a friendly community!",
  "property_seo_title_residentaccess": "Resident Access | Artisan Crossing Apts",
  "property_seo_description_residentaccess": "Seamlessly manage life at Artisan Crossing Apts in Norman! Log in to your resident portal for easy rent payment, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Artisan Crossing Apts",
  "property_seo_description_referafriend": "Refer a friend to Artisan Crossing Apts in Norman, OK! Great friends make great neighbors—share the charm of our vibrant community and enjoy perks together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Artisan Crossing Apts",
  "property_seo_description_scheduletour": "Experience the charm of Artisan Crossing Apts in Norman, OK. Schedule your tour today and imagine your future in our vibrant, welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Artisan Crossing Apts",
  "property_seo_description_privacy": "Your privacy matters at Artisan Crossing Apts in Norman, OK. Learn how we protect your personal information by viewing our detailed privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Artisan Crossing Apts",
  "property_seo_description_accessibility": "At Artisan Crossing Apts in Norman, we prioritize accessibility and inclusion for all. Join our welcoming community where everyone is valued and comfortable.",
  "property_seo_title_sitemap": "Sitemap | Artisan Crossing Apts",
  "property_seo_description_sitemap": "Uncover the layout of Artisan Crossing Apts in Norman, OK! Navigate our sitemap for a seamless journey through your future home and community amenities.",
  "property_seo_title_thankyou": "Thank You | Artisan Crossing Apts",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to vibrant living at Artisan Crossing Apts in Norman, OK starts here. Our team will be in touch soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Norman, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787864765490",
  "amenities": [
    {
      "id": "ec_c4b9349785731067f0f8d2f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127396209",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2245eb550070832a68cde6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127396211",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb7b8343574e110dc992d127",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127396212",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_38d701e6ba93d53e7b4b793f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127396213",
      "title": "Gated Electronic Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_edbcdba4b2a29f4a8402b6af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127396214",
      "title": "Resort-Worthy Swimming Pool with Sundeck & Cabana Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_850bceb3cf175f859ab6d67d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127396215",
      "title": "Lush Courtyard with Pet Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_537f1fc573362d7693bb4762",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127396216",
      "title": "Internet Cafe with Complimentary Gourmet Coffee & Tea",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca8a585dfb86dc2fb937f1d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127396217",
      "title": "Onsite Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f73b11a6c5ef0d88989d7cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127396218",
      "title": "Clubhouse with Billiard Table",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1f6fcdbf9bc9009ad0b0aa11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127396219",
      "title": "Secure Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6ecdec851645ff0f69c12c96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127396220",
      "title": "Onsite Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d9cabf161d4c2e23a827409d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127396221",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a5f0e0a4d1f9d91982041a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127396222",
      "title": "Online Payments Accepted",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e830b794bb6c8fc8d970186f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127397716",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21a6a2927470a7c1d17addcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127397717",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_98c7878eafdd175b3f7b7548",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127397718",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e468412bb836b06b3a73bb94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127397719",
      "title": "Accessible*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cfa08fb96f9fdea9ffdc77f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127397720",
      "title": "Attached* & Detached Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2034ce16e36cbf804896f7bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127397721",
      "title": "Central Heat & Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_521bdb608619accbd40aeb7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127397722",
      "title": "Dishwasher & Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bbf8b5b27c98fd4fb95913dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127397723",
      "title": "Espresso or Dove Gray Cabinets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6954a95d68f37c7898305c0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127397724",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7c15efe84aa87029aa4ae12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127397725",
      "title": "Modern LED Fireplaces*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_620690dd8e30fd1f1589a564",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127397726",
      "title": "New & Modern Construction",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_55082518a42b9fe74b2a1128",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127397727",
      "title": "Oversized & Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cfb4be15403fd42cfb9cdc8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127397728",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed1c62fbfcb6dbb6b658cbdb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127397729",
      "title": "Private Balcony or Patio*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba489b0d1f6e18c4de07b3b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127397730",
      "title": "Side-By-Side Refrigerator with Ice Maker & Filtered Water",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b60b40bbd51e57657635c2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127397731",
      "title": "Stylish Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9370c1351fa51027869904a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "yardi",
      "external_id": "127397732",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_483dd910-5143-4507-aff6-be090f35af3d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f0040-8dbf-7326-a5bf-293c4aae12f6.webp",
      "image_media": {
        "alt_text": "A primary bedroom with a king-sized bed and blue bedding.",
        "public_id": "019f0040-8dbf-7326-a5bf-293c4aae12f6",
        "storage_key": "property/6767906449165585/019f0040-8dbf-7326-a5bf-293c4aae12f6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this spacious primary bedroom, featuring a comfortable king-sized bed with elegant blue bedding, perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "A primary bedroom with a king-sized bed and blue bedding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_702386ca-ba5b-48d8-a752-d2e4c4d6f4d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f0040-7c63-72c5-9a3d-b4451e3ac518.webp",
      "image_media": {
        "alt_text": "Balcony view of a resort-style pool and apartment buildings.",
        "public_id": "019f0040-7c63-72c5-9a3d-b4451e3ac518",
        "storage_key": "property/6767906449165585/019f0040-7c63-72c5-9a3d-b4451e3ac518.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony overlooking the sparkling resort-style pool and surrounding apartment buildings.",
      "link": "",
      "alt_text": "Balcony view of a resort-style pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b6ae6072-706c-46b6-a421-7eace0ff7567",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f0040-a970-730b-a8eb-6e7db03a9a26.webp",
      "image_media": {
        "alt_text": "Modern apartment complex gym with various weight machines, treadmills, and free weights.",
        "public_id": "019f0040-a970-730b-a8eb-6e7db03a9a26",
        "storage_key": "property/6767906449165585/019f0040-a970-730b-a8eb-6e7db03a9a26.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Stay active and healthy in our fully-equipped fitness center, featuring state-of-the-art cardio and strength training equipment.",
      "link": "",
      "alt_text": "Modern apartment complex gym with various weight machines, treadmills, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_97f9cf1e-fd8b-4aa0-8dfa-005085dfd827",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f0040-97c9-70ec-a33c-b78c65f99ce9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white subway tile backsplash.",
        "public_id": "019f0040-97c9-70ec-a33c-b78c65f99ce9",
        "storage_key": "property/6767906449165585/019f0040-97c9-70ec-a33c-b78c65f99ce9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience gourmet cooking in this stylish kitchen featuring dark wood cabinetry, a microwave, a full-size oven, and a dishwasher.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_81ce3713-b918-4b80-a26a-e3db6f677f4e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f0040-ad05-7334-b56c-8ca184c84091.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and white subway tile backsplash.",
        "public_id": "019f0040-ad05-7334-b56c-8ca184c84091",
        "storage_key": "property/6767906449165585/019f0040-ad05-7334-b56c-8ca184c84091.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed kitchen, featuring sleek gray cabinetry, a full suite of stainless steel appliances, and a classic white subway tile backsplash. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and white subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d5d1f66e-5470-4888-a734-26224f0ce939",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f0040-48eb-77db-a550-50c2c86fccbd.webp",
      "image_media": {
        "alt_text": "Modern living area with leather sofas, fireplace, and large TV, adjacent to a business center and game room.",
        "public_id": "019f0040-48eb-77db-a550-50c2c86fccbd",
        "storage_key": "property/6767906449165585/019f0040-48eb-77db-a550-50c2c86fccbd.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Experience comfort and style in our community's shared spaces, featuring a chic lounge, a business center, and a game room with a pool table.",
      "link": "",
      "alt_text": "Modern living area with leather sofas, fireplace, and large TV, adjacent to a business center and game room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_87613d3c-5576-461a-b51b-fdd366f7df8c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f0040-a101-776a-9f66-ead7c157b60a.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sectional sofa, ottoman, accent chair, and a desk.",
        "public_id": "019f0040-a101-776a-9f66-ead7c157b60a",
        "storage_key": "property/6767906449165585/019f0040-a101-776a-9f66-ead7c157b60a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed living space, featuring a plush sectional sofa, comfortable accent chair, and a convenient desk area perfect for work or study.",
      "link": "",
      "alt_text": "Spacious living room with a sectional sofa, ottoman, accent chair, and a desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1a014ee8-59fb-4bc6-886f-8e3ae0546e1e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f0040-3053-757b-bb67-d5926b62020f.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with marble countertop, sink, and mirror.",
        "public_id": "019f0040-3053-757b-bb67-d5926b62020f",
        "storage_key": "property/6767906449165585/019f0040-3053-757b-bb67-d5926b62020f.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Apartment",
      "description": "Modern bathroom vanity with marble countertop, sink, and mirror. Includes decorative artwork and a wicker hamper.",
      "link": "",
      "alt_text": "Bathroom vanity with marble countertop, sink, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_14199c2b-23d4-43e4-9623-f8b1abb139c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f0040-818a-727e-a6ec-24ea4ac3e5a2.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, blue patterned comforter, and decorative wall art.",
        "public_id": "019f0040-818a-727e-a6ec-24ea4ac3e5a2",
        "storage_key": "property/6767906449165585/019f0040-818a-727e-a6ec-24ea4ac3e5a2.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Apartment",
      "description": "Relax and unwind in this comfortable bedroom, featuring a plush queen-size bed with elegant blue patterned bedding and stylish wall decor.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, blue patterned comforter, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_45c28e2f-b2b6-45eb-9a6d-bccf7679787b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f0040-6412-724e-a95e-bbc2506ed973.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with a parking lot and golf cart.",
        "public_id": "019f0040-6412-724e-a95e-bbc2506ed973",
        "storage_key": "property/6767906449165585/019f0040-6412-724e-a95e-bbc2506ed973.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to this stunning apartment complex, featuring a modern exterior design with ample parking and a convenient golf cart.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with a parking lot and golf cart.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_27f7ab62-db45-4491-b186-9a82e929d2ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f0040-57b9-761f-ba0d-fc034a3c5e80.webp",
      "image_media": {
        "alt_text": "Community lounge with pool table, bar, and lounge seating.",
        "public_id": "019f0040-57b9-761f-ba0d-fc034a3c5e80",
        "storage_key": "property/6767906449165585/019f0040-57b9-761f-ba0d-fc034a3c5e80.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy leisure and entertainment in our vibrant community lounge, featuring a billiards table and a fully equipped bar area perfect for socializing.",
      "link": "",
      "alt_text": "Community lounge with pool table, bar, and lounge seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_248e4275-35be-4d5c-a29f-3d4032785036",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f0040-2981-75ce-9d11-08e17c2eae00.webp",
      "image_media": {
        "alt_text": "Modern bathroom with marble countertop, white sink, dark cabinets, and decorative art.",
        "public_id": "019f0040-2981-75ce-9d11-08e17c2eae00",
        "storage_key": "property/6767906449165585/019f0040-2981-75ce-9d11-08e17c2eae00.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Elegantly designed bathroom featuring a spacious marble countertop, a clean white sink, ample storage with dark cabinetry, and artistic wall decor.",
      "link": "",
      "alt_text": "Modern bathroom with marble countertop, white sink, dark cabinets, and decorative art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ccf76cd4-0370-4134-b2d5-182c8b5e5054",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f0040-3b90-763d-9220-7c173f44c028.webp",
      "image_media": {
        "alt_text": "Bedroom with king-size bed, nightstands, dresser, and window.",
        "public_id": "019f0040-3b90-763d-9220-7c173f44c028",
        "storage_key": "property/6767906449165585/019f0040-3b90-763d-9220-7c173f44c028.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and elegantly appointed bedroom featuring a comfortable king-size bed, decorative pillows, and stylish furnishings.",
      "link": "",
      "alt_text": "Bedroom with king-size bed, nightstands, dresser, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f32001e7-23d2-40ce-ab47-5d0c3200a4dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f003f-a9cc-72a3-a7cf-a0626d0f2fa3.webp",
      "image_media": {
        "alt_text": "Dog park with artificial turf, a bench, and waste bin.",
        "public_id": "019f003f-a9cc-72a3-a7cf-a0626d0f2fa3",
        "storage_key": "property/6767906449165585/019f003f-a9cc-72a3-a7cf-a0626d0f2fa3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our dedicated dog park, featuring artificial turf for playtime and a comfortable bench for relaxation. Waste stations are available for convenience.",
      "link": "",
      "alt_text": "Dog park with artificial turf, a bench, and waste bin.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d93a6c09-a101-459b-b873-c50f7254202d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f0040-3f30-72e9-ad93-5b6967503eb0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, white subway tile backsplash, and stainless steel appliances.",
        "public_id": "019f0040-3f30-72e9-ad93-5b6967503eb0",
        "storage_key": "property/6767906449165585/019f0040-3f30-72e9-ad93-5b6967503eb0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and stylish kitchen featuring dark wood cabinetry, marble countertops, stainless steel appliances, and ample counter space for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, white subway tile backsplash, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a04175fb-076b-4a3b-9195-87c3966b5729",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f003f-bf60-760d-99c0-4da472b18662.webp",
      "image_media": {
        "alt_text": "Living room and dining area with blue sofa, accent chair, and dining table.",
        "public_id": "019f003f-bf60-760d-99c0-4da472b18662",
        "storage_key": "property/6767906449165585/019f003f-bf60-760d-99c0-4da472b18662.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this inviting living and dining area, featuring a plush blue sofa, a decorative accent chair, and a modern dining set, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and dining area with blue sofa, accent chair, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2871ec5a-18d8-4e47-a327-228ea606f725",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f0040-0947-74bb-9bf3-8c548dd96309.webp",
      "image_media": {
        "alt_text": "Modern bathroom with subway tile shower, vanity with marble countertop, and decorative accents.",
        "public_id": "019f0040-0947-74bb-9bf3-8c548dd96309",
        "storage_key": "property/6767906449165585/019f0040-0947-74bb-9bf3-8c548dd96309.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a spa-like experience in this beautifully appointed bathroom, featuring elegant finishes and ample counter space.",
      "link": "",
      "alt_text": "Modern bathroom with subway tile shower, vanity with marble countertop, and decorative accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d4253e1b-4980-4561-8fc7-ec546ddd5caf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f003f-a9cd-75c6-bee1-338ec06978ce.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen bed, white dresser, and bedside table.",
        "public_id": "019f003f-a9cd-75c6-bee1-338ec06978ce",
        "storage_key": "property/6767906449165585/019f003f-a9cd-75c6-bee1-338ec06978ce.webp",
        "width": 3072,
        "height": 2038
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a queen-size bed with a cozy orange comforter and a plush white throw, complemented by a sleek white dresser and nightstand for ample storage.",
      "link": "",
      "alt_text": "Modern bedroom with a queen bed, white dresser, and bedside table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_24bf9526-a989-4a24-96ff-db5dd20e52fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f003f-c192-7547-aae8-53c22ff3b087.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and ceiling fan.",
        "public_id": "019f003f-c192-7547-aae8-53c22ff3b087",
        "storage_key": "property/6767906449165585/019f003f-c192-7547-aae8-53c22ff3b087.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable king-size bed with plush bedding, a stylish dresser with a mirror, and a modern ceiling fan.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fd69d1cb-920a-4a9e-be51-1e582748adf7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f003f-a6b1-7182-9cd7-64e6dfb0114c.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a marble vanity, white subway tile shower, and red shower curtain.",
        "public_id": "019f003f-a6b1-7182-9cd7-64e6dfb0114c",
        "storage_key": "property/6767906449165585/019f003f-a6b1-7182-9cd7-64e6dfb0114c.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Elegant and spacious bathroom featuring a sleek marble vanity, a deep soaking tub with a vibrant red shower curtain, and clean white subway tile accents.",
      "link": "",
      "alt_text": "Modern bathroom with a marble vanity, white subway tile shower, and red shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_32efcdb3-4e67-4ddb-82ff-eea80ac59c73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f003f-ab06-73eb-834e-0c1ed5698b3e.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with marble countertop, sink, faucet, and decorative items.",
        "public_id": "019f003f-ab06-73eb-834e-0c1ed5698b3e",
        "storage_key": "property/6767906449165585/019f003f-ab06-73eb-834e-0c1ed5698b3e.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a spacious vanity with a marble-look countertop, a clean white sink, and a modern faucet, complemented by decorative accents.",
      "link": "",
      "alt_text": "Modern bathroom vanity with marble countertop, sink, faucet, and decorative items.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a93bc70b-e2bd-4e47-9be4-090169016047",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f003f-bc83-70aa-9a35-8de2dc561bc0.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with grey siding and brick accents, parking lot, and landscaping.",
        "public_id": "019f003f-bc83-70aa-9a35-8de2dc561bc0",
        "storage_key": "property/6767906449165585/019f003f-bc83-70aa-9a35-8de2dc561bc0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring grey siding, brick details, balconies, and ample parking. Enjoy comfortable living in this well-maintained community.",
      "link": "",
      "alt_text": "Exterior view of a multi-story apartment building with grey siding and brick accents, parking lot, and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_bd86523e-a061-4dc1-87ab-b8cf550f1c23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Tamashii Ramen House- Norman",
      "poi_type": "Restaurants",
      "poi_address": "126 W Main St, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this ramen restaurant serves delicious garlic fried rice, spicy ramen, and tonkotsu ramen. They highlight the flavorful broth, tender chicken, and generous portions. They also like the fun, anime-themed atmosphere and the attentive, friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-dce3-760c-853c-0c1be227ab8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-dce3-760c-853c-0c1be227ab8f",
        "storage_key": "property/6767906449165585/019d2708-dce3-760c-853c-0c1be227ab8f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://tamashiiokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1400114531233121933&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tamashii-ramen-house--norman",
      "poi_latitude": "35.2199606",
      "poi_longitude": "-97.4448329",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-855-0999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1940-76d8-a222-5a35e8a57c50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1940-76d8-a222-5a35e8a57c50",
        "storage_key": "property/6767906449165585/019d2709-1940-76d8-a222-5a35e8a57c50.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ74AQ9KppsocRjUYDf780bhM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ramen_restaurant"
    },
    {
      "id": "custom_85b24702-61b0-4622-9219-17fbadd64413",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Tarahumara's Méxican Cafe & Cantina",
      "poi_type": "Restaurants",
      "poi_address": "702 N Porter Ave, Norman, OK 73071, USA",
      "poi_short_description": "Relaxed eatery serving up Mexican standards like tacos, fajitas, burritos and enchiladas, along with margaritas.",
      "poi_long_description": "People say this Mexican restaurant serves delicious chicken fajitas, chips and salsa, and queso. They highlight the generous portions, fast service, and excellent margaritas. They also like the attentive and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-dc85-70a5-b732-eeb32658dd2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-dc85-70a5-b732-eeb32658dd2f",
        "storage_key": "property/6767906449165585/019d2708-dc85-70a5-b732-eeb32658dd2f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tarahumarasmexicancafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=439215236524010818&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tarahumaras-mxican-cafe--cantina",
      "poi_latitude": "35.22780820000001",
      "poi_longitude": "-97.4413034",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-360-8070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1940-76d8-a222-5a35e8a57c50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1940-76d8-a222-5a35e8a57c50",
        "storage_key": "property/6767906449165585/019d2709-1940-76d8-a222-5a35e8a57c50.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtTMsguBpsocRQu3zOO5nGAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_9ca6d49d-50ad-4519-a4fd-c0fcad255842",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2001 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "Fast-food joint known for chicken sandwiches and waffle fries, and offering a kids' menu.",
      "poi_long_description": "People say this fast food restaurant serves chicken sandwiches and cob salads. They also highlight the friendly staff and fast service.\n\nOther reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-dd69-764e-a12c-bbf528e4280d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-dd69-764e-a12c-bbf528e4280d",
        "storage_key": "property/6767906449165585/019d2708-dd69-764e-a12c-bbf528e4280d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/moore?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=1304875027432141954&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.3186309",
      "poi_longitude": "-97.4951348",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-799-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1940-76d8-a222-5a35e8a57c50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1940-76d8-a222-5a35e8a57c50",
        "storage_key": "property/6767906449165585/019d2709-1940-76d8-a222-5a35e8a57c50.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-8xCoDtrsocRgvRehuzYGxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_a696823f-d02d-4e76-b535-df97022fe032",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Neighborhood JAM",
      "poi_type": "Restaurants",
      "poi_address": "102 W Main St, Norman, OK 73069, USA",
      "poi_short_description": "Relaxed breakfast restaurant serving avocado toast, pancakes and other familiar dishes.",
      "poi_long_description": "People say this breakfast restaurant serves delicious biscuits, scrambles, and breakfast tacos. They highlight the well-thought-out menu with many options, and the fresh, hot food. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-dc92-7369-936d-deabb8b63ffe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-dc92-7369-936d-deabb8b63ffe",
        "storage_key": "property/6767906449165585/019d2708-dc92-7369-936d-deabb8b63ffe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thatsmyjamok.com/locations/norman/",
      "poi_directions_map_url": "https://maps.google.com/?cid=132307001450143405&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "neighborhood-jam",
      "poi_latitude": "35.220375",
      "poi_longitude": "-97.4439773",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-310-2127",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1940-76d8-a222-5a35e8a57c50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1940-76d8-a222-5a35e8a57c50",
        "storage_key": "property/6767906449165585/019d2709-1940-76d8-a222-5a35e8a57c50.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ50SsXCFpsocRrZ67ToQM1gE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_248f02a0-da27-483b-9a5d-e25e04a682f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "800 N Interstate Dr, Norman, OK 73072, USA",
      "poi_short_description": "Relaxed outpost dishing up homestyle American eats such as buttermilk pancakes, plus a gift shop.",
      "poi_long_description": "People say this restaurant serves delicious chicken and dumplings, chicken fried steak, and hashbrown casserole. They also highlight the friendly staff, the cozy atmosphere, and the unique shopping experience.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-e291-7668-a09b-76a07efc44a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e291-7668-a09b-76a07efc44a1",
        "storage_key": "property/6767906449165585/019d2708-e291-7668-a09b-76a07efc44a1.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/ok/norman/181/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=12360073832655434620&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "35.2284997",
      "poi_longitude": "-97.4867749",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-360-3117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1940-76d8-a222-5a35e8a57c50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1940-76d8-a222-5a35e8a57c50",
        "storage_key": "property/6767906449165585/019d2709-1940-76d8-a222-5a35e8a57c50.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl6kFdnRpsocRfDMHEarNh6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_83c5bd58-9fc4-40f4-8030-702606afde70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Sooner Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "3301 W Main St, Norman, OK 73072, USA",
      "poi_short_description": "Enclosed mall featuring apparel and sporting goods stores, a food court, and a playground.",
      "poi_long_description": "Covered complex for shopping & dining plus a trampoline park & virtual reality experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-e23c-7589-b1e9-e1ae21f4b468.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e23c-7589-b1e9-e1ae21f4b468",
        "storage_key": "property/6767906449165585/019d2708-e23c-7589-b1e9-e1ae21f4b468.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.soonermall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7755349768317849569&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sooner-mall",
      "poi_latitude": "35.2200122",
      "poi_longitude": "-97.4907714",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-360-0341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-191f-710e-b720-fbc39eb01b23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-191f-710e-b720-fbc39eb01b23",
        "storage_key": "property/6767906449165585/019d2709-191f-710e-b720-fbc39eb01b23.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH3uVDQ5psocR4U9-UYaJoGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_60b94cb9-cfb4-42de-94c4-0aa7d99d499b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "2555 Hemphill Dr, Norman, OK 73069, USA",
      "poi_short_description": "Chain supplying home-improvement materials, appliances, paint, and patio furniture, plus lawn-equipment rental.",
      "poi_long_description": "People say this home improvement store offers a wide variety of products. They also highlight the helpful staff and quick and easy pick-up service.\n\nOther reviews mention the inventory can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-e22d-7680-98f4-67ee213a8e8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e22d-7680-98f4-67ee213a8e8e",
        "storage_key": "property/6767906449165585/019d2708-e22d-7680-98f4-67ee213a8e8e.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Norman/1165?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1165-_-na-_-0-_-0&y_source=1_MTE4MzI1MC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16039383829879335227&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "35.224972",
      "poi_longitude": "-97.481412",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-329-2009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-191f-710e-b720-fbc39eb01b23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-191f-710e-b720-fbc39eb01b23",
        "storage_key": "property/6767906449165585/019d2709-191f-710e-b720-fbc39eb01b23.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi62bmwppsocROyka7JxWl94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_68011379-0fbc-4cce-a75f-cea27c283b00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "850 Ed Noble Pkwy, Norman, OK 73072, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has helpful and knowledgeable staff who are always willing to assist customers with their projects. They also highlight the well-stocked inventory, with a wide variety of items for both personal and professional needs.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-e3ac-725f-bcc9-badc3b5e8cda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e3ac-725f-bcc9-badc3b5e8cda",
        "storage_key": "property/6767906449165585/019d2708-e3ac-725f-bcc9-badc3b5e8cda.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Norman/OK/Norman/73072/3906?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=2554053834785429710&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.2082106",
      "poi_longitude": "-97.4836927",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-579-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-191f-710e-b720-fbc39eb01b23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-191f-710e-b720-fbc39eb01b23",
        "storage_key": "property/6767906449165585/019d2709-191f-710e-b720-fbc39eb01b23.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVXAm0wBpsocRzhicR27ScSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_2d13b90f-24cd-41f7-b220-a97d7b6090c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "755 SW 19th St, Moore, OK 73160, USA",
      "poi_short_description": "Grocery store stocking bulk items, organic products, and prepared foods, plus a deli and a bakery.",
      "poi_long_description": "People say this supermarket offers a wide variety of bulk foods, including spices, nuts, seeds, flours, and baking needs, as well as a large selection of candy, coffee, and pizza. They highlight the great prices, especially on bulk items, and the clean, well-stocked store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-e6fa-71a9-904c-b6883321f523.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e6fa-71a9-904c-b6883321f523",
        "storage_key": "property/6767906449165585/019d2708-e6fa-71a9-904c-b6883321f523.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16116728468117303121&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "35.3211875",
      "poi_longitude": "-97.501428",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-759-6329",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-195f-7754-b817-b13e458c8d8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-195f-7754-b817-b13e458c8d8f",
        "storage_key": "property/6767906449165585/019d2709-195f-7754-b817-b13e458c8d8f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGQsfeThrsocRUa-O0yYfqt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_9335fa69-36dc-4b0f-bf9a-08f77730079a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Crest Fresh Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2550 Mt Williams Dr, Norman, OK 73069, USA",
      "poi_short_description": "Vast, 24/7, chain offering groceries ranging from the basics to gourmet fare, plus bakery items and deli treats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-e73e-722d-9527-7d05e6de909e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e73e-722d-9527-7d05e6de909e",
        "storage_key": "property/6767906449165585/019d2708-e73e-722d-9527-7d05e6de909e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.crestfoodsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1924302074676916156&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crest-fresh-market",
      "poi_latitude": "35.2375928",
      "poi_longitude": "-97.4791021",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-809-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-195f-7754-b817-b13e458c8d8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-195f-7754-b817-b13e458c8d8f",
        "storage_key": "property/6767906449165585/019d2709-195f-7754-b817-b13e458c8d8f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3ZuH6IJpsocRvC-qoYp-tBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_dd9f5d4d-82b3-471e-b1e3-343573e5fed8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "The University of Oklahoma",
      "poi_type": "Education",
      "poi_address": "660 Parrington Oval, Norman, OK 73019, USA",
      "poi_short_description": "Founded in 1890, this research school is home to a sprawling museum dedicated to natural history.",
      "poi_long_description": "Founded in 1890, this research school is home to a sprawling museum dedicated to natural history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-ea59-7419-84f4-bd1c7778b219.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ea59-7419-84f4-bd1c7778b219",
        "storage_key": "property/6767906449165585/019d2708-ea59-7419-84f4-bd1c7778b219.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5385970366617493076&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-university-of-oklahoma",
      "poi_latitude": "35.1987162",
      "poi_longitude": "-97.4448963",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-325-0311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1911-74fe-b330-08fd6df26c89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1911-74fe-b330-08fd6df26c89",
        "storage_key": "property/6767906449165585/019d2709-1911-74fe-b330-08fd6df26c89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu1B_5itosocRVB4EKYPPvko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b9ea091e-c8fb-4602-9f04-e05837709d21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Pioneer Library System - Moore Public Library",
      "poi_type": "Education",
      "poi_address": "225 S Howard Ave, Moore, OK 73160, USA",
      "poi_short_description": "Local institution that provides books, DVDs, computers and programs, with an emphasis on children's offerings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-e9ed-721e-ad7f-9900e8b76af8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e9ed-721e-ad7f-9900e8b76af8",
        "storage_key": "property/6767906449165585/019d2708-e9ed-721e-ad7f-9900e8b76af8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://pioneerlibrarysystem.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13566280005030728682&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pioneer-library-system---moore-public-library",
      "poi_latitude": "35.3358205",
      "poi_longitude": "-97.4885841",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-793-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1d80-7639-96ed-48ec24d5c5c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1d80-7639-96ed-48ec24d5c5c9",
        "storage_key": "property/6767906449165585/019d2709-1d80-7639-96ed-48ec24d5c5c9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0xg3BdMUsocR6lNXj8kbRbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_7cd742ec-f537-4fea-9b04-fb6a8d28bad9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Bizzell Memorial Library",
      "poi_type": "Education",
      "poi_address": "Bizzell Memorial Library, 401 W Brooks St, Norman, OK 73019, USA",
      "poi_short_description": "Handsome academic institution boasting 8 floors of books and meeting spaces, plus a coffee shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-eda9-726c-a09f-b47fb8aaa7e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-eda9-726c-a09f-b47fb8aaa7e5",
        "storage_key": "property/6767906449165585/019d2708-eda9-726c-a09f-b47fb8aaa7e5.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://libraries.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12214855868594969836&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bizzell-memorial-library",
      "poi_latitude": "35.2080168",
      "poi_longitude": "-97.4456785",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-325-3341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1d80-7639-96ed-48ec24d5c5c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1d80-7639-96ed-48ec24d5c5c9",
        "storage_key": "property/6767906449165585/019d2709-1d80-7639-96ed-48ec24d5c5c9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv2Nnk39CsocR7NwyBrLig6k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_7cf381e8-73d2-43b3-a964-4938731f118f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Randall University",
      "poi_type": "Education",
      "poi_address": "3701 S I-35 Service Rd, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-ef59-753a-a2b2-92f6fa7d0494.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ef59-753a-a2b2-92f6fa7d0494",
        "storage_key": "property/6767906449165585/019d2708-ef59-753a-a2b2-92f6fa7d0494.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.ru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1911580702336403596&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "randall-university",
      "poi_latitude": "35.300769",
      "poi_longitude": "-97.491047",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-912-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1911-74fe-b330-08fd6df26c89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1911-74fe-b330-08fd6df26c89",
        "storage_key": "property/6767906449165585/019d2709-1911-74fe-b330-08fd6df26c89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7VS3UoQWsocRjMhAUoVMhxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e91840ad-dc15-4210-bf2d-a197b18f511a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Pioneer Library System - Norman Public Library East",
      "poi_type": "Education",
      "poi_address": "3051 E Alameda St, Norman, OK 73071, USA",
      "poi_short_description": "Neighborhood branch of the public library system offers books and computer access, plus 3D printers.",
      "poi_long_description": "People say this public library has a wonderful children's area and helpful staff. They also highlight the clean, tidy, and cozy space with beautiful views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-f04a-7718-a85a-fedeb634fdbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f04a-7718-a85a-fedeb634fdbe",
        "storage_key": "property/6767906449165585/019d2708-f04a-7718-a85a-fedeb634fdbe.webp",
        "width": 1280,
        "height": 1028
      },
      "poi_business_url": "https://www.pioneerlibrarysystem.org/choose-a-library/norman-east",
      "poi_directions_map_url": "https://maps.google.com/?cid=17936631778263869986&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pioneer-library-system---norman-public-library-east",
      "poi_latitude": "35.2186547",
      "poi_longitude": "-97.3958326",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-217-0770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1911-74fe-b330-08fd6df26c89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1911-74fe-b330-08fd6df26c89",
        "storage_key": "property/6767906449165585/019d2709-1911-74fe-b330-08fd6df26c89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_-ry_DRDsocRIqpm6pG36_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_5c589e31-2c57-4a44-88b7-11ef259923be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Lloyd Noble Center",
      "poi_type": "Entertainment",
      "poi_address": "2900 S Jenkins Ave, Norman, OK 73019, USA",
      "poi_short_description": "Host for Sooner basketball games and women's gymnastics events.",
      "poi_long_description": "People say this arena offers a great atmosphere for watching college basketball games and epic graduation ceremonies. They also highlight the clean facilities, comfortable seating, and easy access with plenty of parking.\n\nOther reviews mention the seats can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-f051-777b-b61f-b9c0e1ef89a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f051-777b-b61f-b9c0e1ef89a0",
        "storage_key": "property/6767906449165585/019d2708-f051-777b-b61f-b9c0e1ef89a0.webp",
        "width": 1280,
        "height": 772
      },
      "poi_business_url": "http://lloydnoblecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14422888574861973776&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lloyd-noble-center",
      "poi_latitude": "35.18733",
      "poi_longitude": "-97.444262",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-325-4666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1d20-743c-9662-f17a31e8ed4b",
        "storage_key": "property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ_v3ECFosocREBmwO75kKMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_67529d60-aafa-4d6f-9b9c-e4a598a4cb67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Gaylord Family - Oklahoma Memorial Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1185 Asp Ave, Norman, OK 73019, USA",
      "poi_short_description": "Stadium for Oklahoma University's football team, set on campus.",
      "poi_long_description": "People say this stadium offers a fun, exciting, and intense college football experience. They highlight the electric atmosphere, energetic crowd, and the easy access to restrooms and food options. They also like the welcoming and delightful staff and environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-f30f-713c-a171-c742b1a08f3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f30f-713c-a171-c742b1a08f3d",
        "storage_key": "property/6767906449165585/019d2708-f30f-713c-a171-c742b1a08f3d.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://soonersports.com/ViewArticle.dbml?&DB_OEM_ID=31000&ATCLID=208803887",
      "poi_directions_map_url": "https://maps.google.com/?cid=1926763231009947154&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gaylord-family---oklahoma-memorial-stadium",
      "poi_latitude": "35.2058537",
      "poi_longitude": "-97.4423145",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-325-2424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1d17-70dd-bb06-dbc8c5562c2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1d17-70dd-bb06-dbc8c5562c2d",
        "storage_key": "property/6767906449165585/019d2709-1d17-70dd-bb06-dbc8c5562c2d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUWBFtdRpsocREr6hPvM8vRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_fc75c657-a7d1-456e-853e-dada83e69c41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Sam Noble Oklahoma Museum of Natural History",
      "poi_type": "Entertainment",
      "poi_address": "2401 Chautauqua Ave, Norman, OK 73072, USA",
      "poi_short_description": "Permanent and rotating displays of dinosaur bones, artifacts and interactive exhibits.",
      "poi_long_description": "Visitors say this natural history museum features a variety of dinosaur exhibits, including fossils found in Oklahoma and the Guinness Book of World Record exhibit for the largest single dinosaur ever found. They also highlight the museum's hands-on learning experiences, immersive displays, and rotating exhibits, making it a great place for families, students, and dinosaur enthusiasts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-f416-758d-8e96-5c5ef98328c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f416-758d-8e96-5c5ef98328c9",
        "storage_key": "property/6767906449165585/019d2708-f416-758d-8e96-5c5ef98328c9.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://samnoblemuseum.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15153822275207383505&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sam-noble-oklahoma-museum-of-natural-history",
      "poi_latitude": "35.1944148",
      "poi_longitude": "-97.4489987",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-325-7977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1d83-75ba-b18d-ed667107bba7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1d83-75ba-b18d-ed667107bba7",
        "storage_key": "property/6767906449165585/019d2709-1d83-75ba-b18d-ed667107bba7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJA5eBNjBosocR0UkjJxIxTdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f8d7a733-3180-4b55-9460-938d261077fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "2800 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "Trampoline park and adventure center featuring go-karts, ropes courses and party rooms.",
      "poi_long_description": "People say this amusement park offers a wide variety of attractions, including go-karts, trampolines, and a ball pit, and is a fun place for birthday parties.\n\nOther reviews mention the go-karts can be slow and the dodgeball area can be unsupervised.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-f5ca-7640-b73e-98a984d2d340.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f5ca-7640-b73e-98a984d2d340",
        "storage_key": "property/6767906449165585/019d2708-f5ca-7640-b73e-98a984d2d340.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-moore/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=454199799262834417&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "35.3130452",
      "poi_longitude": "-97.4932574",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-655-5805",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1d20-743c-9662-f17a31e8ed4b",
        "storage_key": "property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcSyRgFtrsocR8W4dnE-kTQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_5f31c135-229c-42fe-a29e-661f0d76673e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Love’s Field",
      "poi_type": "Entertainment",
      "poi_address": "107 E Constitution St, Norman, OK 73072, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this stadium offers a great place to watch softball. They highlight the intimate atmosphere, excellent seating, and clean facilities. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-f59f-753e-bf1c-705746af65c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f59f-753e-bf1c-705746af65c7",
        "storage_key": "property/6767906449165585/019d2708-f59f-753e-bf1c-705746af65c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12522865308570512153&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-field",
      "poi_latitude": "35.1909663",
      "poi_longitude": "-97.442259",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1d17-70dd-bb06-dbc8c5562c2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1d17-70dd-bb06-dbc8c5562c2d",
        "storage_key": "property/6767906449165585/019d2709-1d17-70dd-bb06-dbc8c5562c2d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl6yiOXVpsocRGWtoL6Ynyq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_6bc8ae30-6411-40d5-bb5a-534db5ec039a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Crunch Fitness - Norman",
      "poi_type": "Health and Wellness",
      "poi_address": "2300 W Main St, Norman, OK 73069, USA",
      "poi_short_description": "Friendly gym offering a wide choice of equipment and classes, as well as tanning beds and massage beds, plus kids’ play areas.",
      "poi_long_description": "People say this gym offers great spray tans and a variety of classes. They also highlight the friendly and helpful staff, the clean facility, and the affordable prices.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-f874-77c4-8d91-2e10c4c0f3f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f874-77c4-8d91-2e10c4c0f3f9",
        "storage_key": "property/6767906449165585/019d2708-f874-77c4-8d91-2e10c4c0f3f9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.crunch.com/locations/norman",
      "poi_directions_map_url": "https://maps.google.com/?cid=6630355039414722733&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---norman",
      "poi_latitude": "35.2168583",
      "poi_longitude": "-97.4760892",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-322-5859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1d20-743c-9662-f17a31e8ed4b",
        "storage_key": "property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpW-RUHJpsocRrSAJe8fAA1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_39232a16-9e7b-4a78-9270-2e4b3ae2ae52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Norman Regional The Health Club",
      "poi_type": "Health and Wellness",
      "poi_address": "2301 36th Ave NW, Norman, OK 73072, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-f8a2-70b7-be61-bbb6f2bb0c6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f8a2-70b7-be61-bbb6f2bb0c6e",
        "storage_key": "property/6767906449165585/019d2708-f8a2-70b7-be61-bbb6f2bb0c6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.normanregional.com/the-health-club/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6654177676307732909&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "norman-regional-the-health-club",
      "poi_latitude": "35.246075",
      "poi_longitude": "-97.4938832",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-329-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1d20-743c-9662-f17a31e8ed4b",
        "storage_key": "property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY3tEmZNpsocRrRmoXFdjWFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_67bee688-2753-4a3f-bbde-27b91d4d3393",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "1620 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Specialty retailer selling makeup, fragrances and skin, body and hair care products from over 500 brands.",
      "poi_long_description": "People say this cosmetics store offers a wide selection of makeup and beauty products. They also highlight the rewards program, which provides discounts and other benefits.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-faf0-7159-9242-40eaba622036.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-faf0-7159-9242-40eaba622036",
        "storage_key": "property/6767906449165585/019d2708-faf0-7159-9242-40eaba622036.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/norman-ok-444",
      "poi_directions_map_url": "https://maps.google.com/?cid=6230795026936720015&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "35.2386275",
      "poi_longitude": "-97.4841919",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-307-9358",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1d20-743c-9662-f17a31e8ed4b",
        "storage_key": "property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFevmiXhpsocRj2rVmBA7eFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_47069a0a-a373-4e99-9b54-48bba04cc230",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "McCasland Field House",
      "poi_type": "Health and Wellness",
      "poi_address": "151 E Brooks St, Norman, OK 73019, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-fc47-7578-9030-66ad2d145f4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-fc47-7578-9030-66ad2d145f4c",
        "storage_key": "property/6767906449165585/019d2708-fc47-7578-9030-66ad2d145f4c.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://soonersports.com/sports/2019/8/12/208803875.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15711730160516803345&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mccasland-field-house",
      "poi_latitude": "35.2079236",
      "poi_longitude": "-97.4423032",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-325-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1911-74fe-b330-08fd6df26c89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1911-74fe-b330-08fd6df26c89",
        "storage_key": "property/6767906449165585/019d2709-1911-74fe-b330-08fd6df26c89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOxFFF9VpsocREStlMFZHC9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_472b1122-f43c-4cbf-9755-82b5ac41565b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Sarkeys Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1401 Asp Ave, Norman, OK 73019, USA",
      "poi_short_description": "University gym and recreation center offering facilities for climbing, basketball, and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-fcfa-7790-b36c-45d1cbe378a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-fcfa-7790-b36c-45d1cbe378a0",
        "storage_key": "property/6767906449165585/019d2708-fcfa-7790-b36c-45d1cbe378a0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ou.edu/far",
      "poi_directions_map_url": "https://maps.google.com/?cid=17771863367383165150&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sarkeys-fitness-center",
      "poi_latitude": "35.2014532",
      "poi_longitude": "-97.4428836",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-325-3053",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1d20-743c-9662-f17a31e8ed4b",
        "storage_key": "property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJheeS3ytosocR3qimwZJXovY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_af31ac1e-010a-40a0-9b8e-f8044b7bca51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1000 E Alameda St, Norman, OK 73071, USA",
      "poi_short_description": "Chain gym featuring a variety of equipment, tanning, and massage chairs, plus an annual fee.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-fdd6-717a-a05b-0f0fcf4f75c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-fdd6-717a-a05b-0f0fcf4f75c8",
        "storage_key": "property/6767906449165585/019d2708-fdd6-717a-a05b-0f0fcf4f75c8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/norman-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=16953030002874658196&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.217743",
      "poi_longitude": "-97.4256219",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-633-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1d20-743c-9662-f17a31e8ed4b",
        "storage_key": "property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJozN9VQ1DsocRlC3ic_dCRes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_be64ba36-a366-4a78-b7dc-88c97bf9cf85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Filed Nails Spa Beauty, Norman, OK",
      "poi_type": "Health and Wellness",
      "poi_address": "3408 36th Ave NW STE 116, Norman, OK 73072, USA",
      "poi_short_description": "Casual nail salon offering manis-pedis, plus acrylics & customized nail art.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2708-ff3a-71c7-8570-56cfb79d3d9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ff3a-71c7-8570-56cfb79d3d9b",
        "storage_key": "property/6767906449165585/019d2708-ff3a-71c7-8570-56cfb79d3d9b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.filednailspa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7696990407116716923&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "filed-nails-spa-beauty-norman-ok",
      "poi_latitude": "35.2587242",
      "poi_longitude": "-97.4947891",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-801-4015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1d20-743c-9662-f17a31e8ed4b",
        "storage_key": "property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtXLsUUdrsocRe_vHr_4z0Wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_0dfc5dd4-c40c-452b-902e-684cac8de3ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Bart Conner Gymnastics Academy",
      "poi_type": "Health and Wellness",
      "poi_address": "3206 Bart Conner Dr, Norman, OK 73072, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-0168-771f-899b-3906975a3de5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0168-771f-899b-3906975a3de5",
        "storage_key": "property/6767906449165585/019d2709-0168-771f-899b-3906975a3de5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bartconnergymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15326641727485596774&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bart-conner-gymnastics-academy",
      "poi_latitude": "35.250054",
      "poi_longitude": "-97.4879725",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-447-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1911-74fe-b330-08fd6df26c89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1911-74fe-b330-08fd6df26c89",
        "storage_key": "property/6767906449165585/019d2709-1911-74fe-b330-08fd6df26c89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxzVqktZrsocRZlR1dnIrs9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fddb95d1-4703-4f5d-99b3-40c176dd9398",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Victory Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "5721 Huettner Dr, Norman, OK 73069, USA",
      "poi_short_description": "Gymnastics center offering recreational classes, AAU and USAG competitive teams, and summer camps.",
      "poi_long_description": "People say this gymnastics center offers recreational classes, private lessons, and summer camps. They highlight the fun and engaging activities, and the positive impact on children's confidence and skills. They also like the kind, patient, and knowledgeable coaches and staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-0227-73cf-a65d-4af49ec87da1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0227-73cf-a65d-4af49ec87da1",
        "storage_key": "property/6767906449165585/019d2709-0227-73cf-a65d-4af49ec87da1.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "http://www.victorygymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16832765422714147590&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "victory-gymnastics",
      "poi_latitude": "35.287754",
      "poi_longitude": "-97.483823",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-688-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1911-74fe-b330-08fd6df26c89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1911-74fe-b330-08fd6df26c89",
        "storage_key": "property/6767906449165585/019d2709-1911-74fe-b330-08fd6df26c89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxeHRVqprsocRBtNa2Pf-mek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_98faec6b-3c3d-491a-83d3-60403e4c4bad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Norman Regional Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Healthplex Pkwy, Norman, OK 73072, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-058d-71aa-b4b3-9593da9515da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-058d-71aa-b4b3-9593da9515da",
        "storage_key": "property/6767906449165585/019d2709-058d-71aa-b4b3-9593da9515da.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.normanregional.com/locations/norman-regional-hospital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5166678913039723209&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "norman-regional-hospital",
      "poi_latitude": "35.2599491",
      "poi_longitude": "-97.4885857",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-515-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-20fd-7488-91d2-89baceb79079.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-20fd-7488-91d2-89baceb79079",
        "storage_key": "property/6767906449165585/019d2709-20fd-7488-91d2-89baceb79079.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJp8UVz89rsocRyeo74Bi7s0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ec32a7e3-b28c-4c1d-b711-4047a472bce0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Norman Regional Moore",
      "poi_type": "Health and Wellness",
      "poi_address": "700 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-0442-757f-896e-b6182fd0ada4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0442-757f-896e-b6182fd0ada4",
        "storage_key": "property/6767906449165585/019d2709-0442-757f-896e-b6182fd0ada4.webp",
        "width": 1280,
        "height": 785
      },
      "poi_business_url": "https://www.normanregional.com/locations/norman-regional-moore/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6671442604466481346&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "norman-regional-moore",
      "poi_latitude": "35.3325506",
      "poi_longitude": "-97.4932073",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-793-9355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-20fd-7488-91d2-89baceb79079.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-20fd-7488-91d2-89baceb79079",
        "storage_key": "property/6767906449165585/019d2709-20fd-7488-91d2-89baceb79079.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJdxkYvjJrsocRwqihsrO5lVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0a433657-86e4-46ff-9a6e-ed12e94986af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Reaves Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2501 Jenkins Ave, Norman, OK 73072, USA",
      "poi_short_description": "Green space featuring a playground and baseball fields, plus an annual medieval fair.",
      "poi_long_description": "People say this park offers a fun wooden playground and separate play areas for different age groups. They highlight the park is clean, well-maintained, and spacious, and the atmosphere is safe and quiet. They also like that it's a great place for family traditions. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-078f-768f-8417-7b9609939112.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-078f-768f-8417-7b9609939112",
        "storage_key": "property/6767906449165585/019d2709-078f-768f-8417-7b9609939112.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.normanok.gov/residents-visitors/parks-recreation/parks/reaves-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16930546161794306208&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "reaves-park",
      "poi_latitude": "35.1938945",
      "poi_longitude": "-97.4407046",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-366-5472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-2162-741f-9805-c676d76fe911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-2162-741f-9805-c676d76fe911",
        "storage_key": "property/6767906449165585/019d2709-2162-741f-9805-c676d76fe911.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNR5d9idosocRoFAaQwhi9eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_70cf7457-5b1c-4af4-aa21-71bb8a7fc068",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Little River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "709 SW 10th St, Moore, OK 73160, USA",
      "poi_short_description": "Family-friendly park with a splash park, a playground and a pirate ship.",
      "poi_long_description": "People say this park offers a fun splash pad with water slides, a playground, and walking trails. They highlight the free admission and the mini water park experience. They also like the plentiful seating and the fenced splash pad.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-0849-74d4-87e9-5e7b6d5a2bf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0849-74d4-87e9-5e7b6d5a2bf7",
        "storage_key": "property/6767906449165585/019d2709-0849-74d4-87e9-5e7b6d5a2bf7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofmoore.com/departments/parks-recreation/locations-amenities/little-river-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13309531068765424630&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "little-river-park",
      "poi_latitude": "35.3275656",
      "poi_longitude": "-97.50192",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-793-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-2162-741f-9805-c676d76fe911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-2162-741f-9805-c676d76fe911",
        "storage_key": "property/6767906449165585/019d2709-2162-741f-9805-c676d76fe911.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1cPHdTZrsocR9svJeP3ztLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a86c15c9-a301-43ee-93df-dca678061d33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Sutton Wilderness Trail Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1920 12th Ave NE, Norman, OK 73071, USA",
      "poi_short_description": "Dog-friendly outdoor lake loop featuring flat trails and wooded areas for walking, jogging and biking.",
      "poi_long_description": "People say this park offers trails for walking, jogging, and biking, as well as fishing and nature exploration. They highlight the peaceful and relaxing atmosphere, and the beautiful scenery with a pond and plenty of shade. They also like that it's pet-friendly and suitable for families.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-09d0-72b4-aff4-735e13c91cbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-09d0-72b4-aff4-735e13c91cbf",
        "storage_key": "property/6767906449165585/019d2709-09d0-72b4-aff4-735e13c91cbf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.normanok.gov/residents-visitors/parks-recreation/parks/george-m-sutton-wilderness-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1152383032856291791&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sutton-wilderness-trail-park",
      "poi_latitude": "35.24229710000001",
      "poi_longitude": "-97.4238198",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-366-5472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-2162-741f-9805-c676d76fe911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-2162-741f-9805-c676d76fe911",
        "storage_key": "property/6767906449165585/019d2709-2162-741f-9805-c676d76fe911.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQYvmTBpCsocRzymWRkMW_g8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b8e65b92-6125-4855-b485-23e349ab8e22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Andrews Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "201 W Daws St, Norman, OK 73069, USA",
      "poi_short_description": "Sprawling destination showcasing multiple playgrounds, a skate park and an amphitheater.",
      "poi_long_description": "People say this park offers an amphitheater, skate park, basketball court, picnic areas, and a splash pad. They highlight the open space, walking trails, and interesting art installations. They also like the gazebos and play parks. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-0a81-76ca-a34a-990367bfdad0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0a81-76ca-a34a-990367bfdad0",
        "storage_key": "property/6767906449165585/019d2709-0a81-76ca-a34a-990367bfdad0.webp",
        "width": 650,
        "height": 424
      },
      "poi_business_url": "https://www.normanok.gov/residents-visitors/parks-recreation/parks/andrews-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15551216504880236359&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "andrews-park",
      "poi_latitude": "35.2240718",
      "poi_longitude": "-97.4478907",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-366-5472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-2162-741f-9805-c676d76fe911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-2162-741f-9805-c676d76fe911",
        "storage_key": "property/6767906449165585/019d2709-2162-741f-9805-c676d76fe911.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9ymuIN1psocRRweUbgQF0dc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b17ed8f2-03a3-4cdd-84c0-0bee4ec0a6b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Ruby Grant Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3110 W Franklin Rd, Norman, OK 73072, USA",
      "poi_short_description": "Park featuring play areas, barbecue grills and disc golf, along with hiking and walking trails.",
      "poi_long_description": "People say this park offers a fun walk and a disc golf course. They highlight the well-maintained area and the full sun exposure. They also like the proximity to a dog park. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-0cb7-7657-9f18-0df8d4b1f170.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0cb7-7657-9f18-0df8d4b1f170",
        "storage_key": "property/6767906449165585/019d2709-0cb7-7657-9f18-0df8d4b1f170.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.normanok.gov/residents-visitors/parks-recreation/parks/ruby-grant-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=69868048196119437&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ruby-grant-park",
      "poi_latitude": "35.2756272",
      "poi_longitude": "-97.489092",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-366-5472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-2162-741f-9805-c676d76fe911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-2162-741f-9805-c676d76fe911",
        "storage_key": "property/6767906449165585/019d2709-2162-741f-9805-c676d76fe911.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYZIsdtrsocRjSvhoZ44-AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_03a88baa-2d7e-4265-943b-932b779ed3ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Max Westheimer Airport KOUN",
      "poi_type": "Transportation & Transit",
      "poi_address": "1700 Lexington Ave #109, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-0d0f-72d8-9008-c6bb607b61f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0d0f-72d8-9008-c6bb607b61f7",
        "storage_key": "property/6767906449165585/019d2709-0d0f-72d8-9008-c6bb607b61f7.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://airport.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12939952151657294093&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "max-westheimer-airport-koun",
      "poi_latitude": "35.2409761",
      "poi_longitude": "-97.4680511",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-325-7233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-218a-76ac-a451-97636d6a8e21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-218a-76ac-a451-97636d6a8e21",
        "storage_key": "property/6767906449165585/019d2709-218a-76ac-a451-97636d6a8e21.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9TluYdpsocRDakVUuzxk7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_77052268-c5c7-46d6-92a6-c3e82c958295",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Norman",
      "poi_type": "Transportation & Transit",
      "poi_address": "200 S Jones Ave, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-0f79-73f9-9d5f-edfb1846f762.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0f79-73f9-9d5f-edfb1846f762",
        "storage_key": "property/6767906449165585/019d2709-0f79-73f9-9d5f-edfb1846f762.webp",
        "width": 1279,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=NOR",
      "poi_directions_map_url": "https://maps.google.com/?cid=15732860998083481142&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "norman",
      "poi_latitude": "35.2198854",
      "poi_longitude": "-97.4428739",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-225e-7589-b07f-874dfb28bc52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-225e-7589-b07f-874dfb28bc52",
        "storage_key": "property/6767906449165585/019d2709-225e-7589-b07f-874dfb28bc52.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJdSTOcdlpsocRNg5ds7hZVto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_47569f1b-58bc-4549-b0f2-26d53e9687b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Simple Modern Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "750 SW 24th St Suite 300, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-0fee-71e5-b90b-8ae6c98bfbe5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0fee-71e5-b90b-8ae6c98bfbe5",
        "storage_key": "property/6767906449165585/019d2709-0fee-71e5-b90b-8ae6c98bfbe5.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "http://simplemodern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5364504164759517206&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "simple-modern-headquarters",
      "poi_latitude": "35.3164404",
      "poi_longitude": "-97.5021957",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1d20-743c-9662-f17a31e8ed4b",
        "storage_key": "property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfe83ix9rsocRFjiYkB2Mcko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_854c93fc-7d20-419c-81e0-841b531a65c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Integrated Power Services (IPS) - Norman",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6707 N Interstate Dr, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1229-7752-9b4f-fee434213f61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1229-7752-9b4f-fee434213f61",
        "storage_key": "property/6767906449165585/019d2709-1229-7752-9b4f-fee434213f61.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://ips.us/location/evans-norman/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2485684183795281028&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integrated-power-services-ips---norman",
      "poi_latitude": "35.2991008",
      "poi_longitude": "-97.4888055",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-631-1344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1d20-743c-9662-f17a31e8ed4b",
        "storage_key": "property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqenS6wRrsocRhKzsbpjsfiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d0014937-b209-42c1-8173-4715f868a5b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "WFEC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3000 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-12ad-7769-a404-64572b8bf394.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-12ad-7769-a404-64572b8bf394",
        "storage_key": "property/6767906449165585/019d2709-12ad-7769-a404-64572b8bf394.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wfec.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11816483374180755416&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wfec",
      "poi_latitude": "35.31055600000001",
      "poi_longitude": "-97.4938519",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-759-2620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1d20-743c-9662-f17a31e8ed4b",
        "storage_key": "property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-U_1KhZrsocR2GdavAWV_KM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_149432d7-49f3-4aab-a9db-fed9dc1ade4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Trans-Tel Central, LLC Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2851 N Flood Ave, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://trans-tel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966786705039048130&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trans-tel-central-llc-corporate-office",
      "poi_latitude": "35.2534979",
      "poi_longitude": "-97.4657052",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-447-5025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1d20-743c-9662-f17a31e8ed4b",
        "storage_key": "property/6767906449165585/019d2709-1d20-743c-9662-f17a31e8ed4b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcWsrK9drsocRwj2MCgBtcHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ccbe5d99-623c-473f-a115-986e8627146e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "N Santa Fe Ave, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-14f6-73ea-8ad2-49908de0772c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-14f6-73ea-8ad2-49908de0772c",
        "storage_key": "property/6767906449165585/019d2709-14f6-73ea-8ad2-49908de0772c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106083913883470512&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-hall",
      "poi_latitude": "35.2216835",
      "poi_longitude": "-97.4467697",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d2709-1d80-7639-96ed-48ec24d5c5c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1d80-7639-96ed-48ec24d5c5c9",
        "storage_key": "property/6767906449165585/019d2709-1d80-7639-96ed-48ec24d5c5c9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ84qUfdtpsocRsEoMEbAEZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_8a0bc2e7-f3c2-4e8f-9ac6-6e0f1845b1c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Roosevelt Elementary School",
      "poi_type": "Education",
      "poi_address": "4250 W Tecumseh Rd, Norman, OK 73072, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.normanpublicschools.org/o/roes",
      "poi_directions_map_url": "https://maps.google.com/?cid=5168077889148460963&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "roosevelt-elementary-school",
      "poi_latitude": "35.2609722",
      "poi_longitude": "-97.5038417",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-447-6581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7be9-719f-a290-64151af599d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7be9-719f-a290-64151af599d2",
        "storage_key": "property/6767906449165585/019cfb39-7be9-719f-a290-64151af599d2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjbW0IOprsocRo58-YnWzuEc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_7d8e73bb-8435-4627-b3fb-81acd6ab9f52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Wilson Elementary School",
      "poi_type": "Education",
      "poi_address": "800 N Peters Ave, Norman, OK 73069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-ad3c-73fa-b6b1-bec285c14b02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ad3c-73fa-b6b1-bec285c14b02",
        "storage_key": "property/6767906449165585/019d7911-ad3c-73fa-b6b1-bec285c14b02.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.normanpublicschools.org/wilson",
      "poi_directions_map_url": "https://maps.google.com/?cid=3315906199454985906&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wilson-elementary-school",
      "poi_latitude": "35.2282046",
      "poi_longitude": "-97.4446895",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-366-5932",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7be9-719f-a290-64151af599d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7be9-719f-a290-64151af599d2",
        "storage_key": "property/6767906449165585/019cfb39-7be9-719f-a290-64151af599d2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKYltWedpsocRsq4Htx53BC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_06a9acc9-520b-42ce-a138-3ac2ddda123a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Eisenhower Elementary School",
      "poi_type": "Education",
      "poi_address": "1415 Fairlawn Dr, Norman, OK 73071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.normanpublicschools.org/o/ees",
      "poi_directions_map_url": "https://maps.google.com/?cid=4518145873560062317&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "eisenhower-elementary-school",
      "poi_latitude": "35.2394087",
      "poi_longitude": "-97.4205053",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-366-5879",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7be9-719f-a290-64151af599d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7be9-719f-a290-64151af599d2",
        "storage_key": "property/6767906449165585/019cfb39-7be9-719f-a290-64151af599d2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiauYqhBCsocRbcnx3Lutsz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_eca3f25f-af71-42a3-8447-5344d22831e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Longfellow Middle School",
      "poi_type": "Education",
      "poi_address": "215 N Ponca Ave, Norman, OK 73071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-ae61-71d6-ac9e-8831048223a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ae61-71d6-ac9e-8831048223a9",
        "storage_key": "property/6767906449165585/019d7911-ae61-71d6-ac9e-8831048223a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.normanpublicschools.org/o/LMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=12176805580318550941&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "longfellow-middle-school",
      "poi_latitude": "35.22490380000001",
      "poi_longitude": "-97.4384107",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-366-5948",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7be9-719f-a290-64151af599d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7be9-719f-a290-64151af599d2",
        "storage_key": "property/6767906449165585/019cfb39-7be9-719f-a290-64151af599d2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbxWjf99psocRnavh6Si0_Kg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_84e7a34e-cba0-4bbd-87bc-1507b9f080e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Alcott Middle School",
      "poi_type": "Education",
      "poi_address": "1919 W Boyd St, Norman, OK 73069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.norman.k12.ok.us/o/ams",
      "poi_directions_map_url": "https://maps.google.com/?cid=517195452663907001&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "alcott-middle-school",
      "poi_latitude": "35.2116707",
      "poi_longitude": "-97.4703548",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-366-5845",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7be9-719f-a290-64151af599d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7be9-719f-a290-64151af599d2",
        "storage_key": "property/6767906449165585/019cfb39-7be9-719f-a290-64151af599d2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJizgKJbBpsocRucJ6I4ZyLQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_8303e5fb-ca98-4512-a2cc-25c28fef7f7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Norman North High School",
      "poi_type": "Education",
      "poi_address": "1809 Stubbeman Ave, Norman, OK 73069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-ae17-733e-a180-8bdf37ed54ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ae17-733e-a180-8bdf37ed54ed",
        "storage_key": "property/6767906449165585/019d7911-ae17-733e-a180-8bdf37ed54ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.normanpublicschools.org/o/nnhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6040937795953896976&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "norman-north-high-school",
      "poi_latitude": "35.2405884",
      "poi_longitude": "-97.4493185",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-366-5954",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7be9-719f-a290-64151af599d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7be9-719f-a290-64151af599d2",
        "storage_key": "property/6767906449165585/019cfb39-7be9-719f-a290-64151af599d2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ46BhfvBpsocREC4QTuu41VM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_8c1af536-bed9-4d1b-98dc-0225bef5b218",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Community Christian School",
      "poi_type": "Education",
      "poi_address": "3002 Broce Dr, Norman, OK 73072, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-aed3-72dd-99a9-9327800cb02f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-aed3-72dd-99a9-9327800cb02f",
        "storage_key": "property/6767906449165585/019d7911-aed3-72dd-99a9-9327800cb02f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.communitychristianschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14100489665613167140&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "community-christian-school",
      "poi_latitude": "35.2537047",
      "poi_longitude": "-97.4866949",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-329-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7be9-719f-a290-64151af599d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7be9-719f-a290-64151af599d2",
        "storage_key": "property/6767906449165585/019cfb39-7be9-719f-a290-64151af599d2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-0nQ49NrsocRJHrwraQAr8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c07515b3-b214-405e-862e-a7e1249c6c33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Oklahoma City Community College",
      "poi_type": "Education",
      "poi_address": "7777 S May Ave, Oklahoma City, OK 73159, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-b9bf-77cc-916c-8475faf3c305.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b9bf-77cc-916c-8475faf3c305",
        "storage_key": "property/6767906449165585/019d7911-b9bf-77cc-916c-8475faf3c305.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.occc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12663331797127596950&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-community-college",
      "poi_latitude": "35.3880406",
      "poi_longitude": "-97.5699184",
      "poi_miles_from_property": "13.7 mi",
      "poi_walking_minutes": "5 hours 5 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-682-1611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7be9-719f-a290-64151af599d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7be9-719f-a290-64151af599d2",
        "storage_key": "property/6767906449165585/019cfb39-7be9-719f-a290-64151af599d2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq1zRlkwSsocRlguzIC0xva8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_05e4073c-8117-457a-a020-eedaad9afe5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "University of Oklahoma North Campus",
      "poi_type": "Education",
      "poi_address": "1928 Goddard Ave, Norman, OK 73069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-b950-721d-a6c5-e1fe129e3fc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b950-721d-a6c5-e1fe129e3fc1",
        "storage_key": "property/6767906449165585/019d7911-b950-721d-a6c5-e1fe129e3fc1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://aviation.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2356597387237958594&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "university-of-oklahoma-north-campus",
      "poi_latitude": "35.2422826",
      "poi_longitude": "-97.4666131",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7be9-719f-a290-64151af599d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7be9-719f-a290-64151af599d2",
        "storage_key": "property/6767906449165585/019cfb39-7be9-719f-a290-64151af599d2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ50quyo5psocRwqPugNZQtCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_63ceb749-c0aa-4697-9642-8369c7db0487",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Land Run Grill",
      "poi_type": "Restaurants",
      "poi_address": "2596 W Tecumseh Rd, Norman, OK 73069, USA",
      "poi_short_description": "Popular family-friendly eatery offering a menu of burgers and other staples, along with games, beer and cocktails.",
      "poi_long_description": "Diners say this bar and grill serves up delicious burgers, chicken fried steak, and quail, with many praising the wide-ranging menu and reasonable prices. They also highlight the friendly and attentive service, as well as the fun and lively atmosphere.\n\nSome reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-b931-7216-b23c-b0a44f633b10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b931-7216-b23c-b0a44f633b10",
        "storage_key": "property/6767906449165585/019d7911-b931-7216-b23c-b0a44f633b10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lrgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8614029648792442992&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "land-run-grill",
      "poi_latitude": "35.261409",
      "poi_longitude": "-97.4800048",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-217-2949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7912-152c-748b-bbc7-26fafaaa007e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-152c-748b-bbc7-26fafaaa007e",
        "storage_key": "property/6767906449165585/019d7912-152c-748b-bbc7-26fafaaa007e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY6XUiF5rsocRcNj0lFMui3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_1237be44-b00d-4194-bf34-e7aa10c6700f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "2070 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "People say this restaurant serves delicious burgers, chicken tenders, and quesadillas. They also highlight the excellent margaritas, the friendly and attentive staff, and the quick service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-c4c7-752a-83fa-3b574eb3abc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c4c7-752a-83fa-3b574eb3abc3",
        "storage_key": "property/6767906449165585/019d7911-c4c7-752a-83fa-3b574eb3abc3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.chilis.com/locations?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=3423207852788408898&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chili-s-grill-bar",
      "poi_latitude": "35.24318700000001",
      "poi_longitude": "-97.481321",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-364-0530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7b82-7227-828e-cc85add157b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7b82-7227-828e-cc85add157b3",
        "storage_key": "property/6767906449165585/019cfb39-7b82-7227-828e-cc85add157b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQyXtiHdrsocRQuLHuWetgS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_17f1c6bd-11f4-4ca9-ad42-4180a5438e49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Redrock Canyon Grill",
      "poi_type": "Restaurants",
      "poi_address": "1820 Legacy Park Drive, Norman, OK 73069, USA",
      "poi_short_description": "Easygoing bistro & bar turning out wood-fired rotisserie chicken & Southwest-inspired dishes.",
      "poi_long_description": "People say this restaurant serves delicious ribs, steak, and rotisserie chicken. They highlight the great atmosphere, friendly staff, and well-timed food arrival. They also like the well-stocked bar and delicious drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-c883-75df-8a43-db86082bbde2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c883-75df-8a43-db86082bbde2",
        "storage_key": "property/6767906449165585/019d7911-c883-75df-8a43-db86082bbde2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.redrockcanyongrill.com/locations/norman/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6133070644336653857&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "redrock-canyon-grill",
      "poi_latitude": "35.2402766",
      "poi_longitude": "-97.4839406",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-701-5501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7b82-7227-828e-cc85add157b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7b82-7227-828e-cc85add157b3",
        "storage_key": "property/6767906449165585/019cfb39-7b82-7227-828e-cc85add157b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA0xD3XhpsocRIfYPskELHVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_5f6dbdf2-8bbe-4edf-8de7-6080d77bcb78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "1300 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Family-friendly chain serving American comfort food with a Texas twist, plus cocktails.",
      "poi_long_description": "People say this restaurant serves delicious chicken fried steak, red beans and rice, and croissants. They also highlight the good service and reasonable prices.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-c96a-74da-b629-386fe71b33dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c96a-74da-b629-386fe71b33dd",
        "storage_key": "property/6767906449165585/019d7911-c96a-74da-b629-386fe71b33dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheddars.com/locations/ok/norman/norman/2040?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:norman-ok-2040_pl:locurl_rd:1034",
      "poi_directions_map_url": "https://maps.google.com/?cid=9148200012400266443&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cheddar-s-scratch-kitchen",
      "poi_latitude": "35.2341518",
      "poi_longitude": "-97.4824377",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-321-3479",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7b82-7227-828e-cc85add157b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7b82-7227-828e-cc85add157b3",
        "storage_key": "property/6767906449165585/019cfb39-7b82-7227-828e-cc85add157b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe6Ydmp1psocRy4xXKXHv9H4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_e2b3214c-f5bd-4245-ad04-e59ab0787485",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Braum's Ice Cream & Dairy Store",
      "poi_type": "Restaurants",
      "poi_address": "1235 N Interstate Dr, Norman, OK 73072, USA",
      "poi_short_description": "Longtime Oklahoma-based chain offering fast-food burgers, ice cream & a full range of groceries.",
      "poi_long_description": "People say this ice cream shop offers delicious ice cream, milkshakes, burgers, and more. They also highlight the friendly and attentive service.\n\nSome reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-c987-743a-a433-1db46ee45492.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c987-743a-a433-1db46ee45492",
        "storage_key": "property/6767906449165585/019d7911-c987-743a-a433-1db46ee45492.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://www.braums.com/store/1235-interstate-dr-norman-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2249198254479964357&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "braum-s-ice-cream-dairy-store",
      "poi_latitude": "35.2339047",
      "poi_longitude": "-97.4865477",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-364-7806",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7b82-7227-828e-cc85add157b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7b82-7227-828e-cc85add157b3",
        "storage_key": "property/6767906449165585/019cfb39-7b82-7227-828e-cc85add157b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo_IJLndpsocRxfi0S-XBNh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "custom_04880829-9b56-4b64-b4dd-eb919f0d3512",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "The Moon Sushi and Asian Bistro",
      "poi_type": "Restaurants",
      "poi_address": "326 E Main St, Norman, OK 73069, USA",
      "poi_short_description": "Comfy standby with arty accents & a sushi bar featuring sashimi & original maki, plus imported beer.",
      "poi_long_description": "People say this sushi restaurant offers delicious sushi with a wide variety of vegetarian options, as well as unique and creative rolls. They highlight the fresh fish, flavorful sauces, and thoughtful presentation, and like the chill, fun, and welcoming atmosphere. They also mention the staff is friendly and attentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-d529-7063-a1af-903385c7f7bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d529-7063-a1af-903385c7f7bd",
        "storage_key": "property/6767906449165585/019d7911-d529-7063-a1af-903385c7f7bd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.themoonsushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10940979217308970420&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-moon-sushi-and-asian-bistro",
      "poi_latitude": "35.2223151",
      "poi_longitude": "-97.4394268",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-857-8244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7b82-7227-828e-cc85add157b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7b82-7227-828e-cc85add157b3",
        "storage_key": "property/6767906449165585/019cfb39-7b82-7227-828e-cc85add157b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe7Q-tdhpsocRtO2hXqEq1pc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_8c736a21-6c3a-4fdd-80fd-4a718e8bf20e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Benvenuti's Ristorante",
      "poi_type": "Restaurants",
      "poi_address": "105 W Main St, Norman, OK 73069, USA",
      "poi_short_description": "Refined option offering elevated Italian fare, prime steaks, seafood & wine amid a cozy ambiance.",
      "poi_long_description": "People say this Italian restaurant serves delicious pizza, pasta, and grilled options, and offers an extensive wine list and cocktails. They highlight the good prices and the cozy, tasteful atmosphere, perfect for a date night or special occasion. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-d8ef-7382-a5f1-329be005c086.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d8ef-7382-a5f1-329be005c086",
        "storage_key": "property/6767906449165585/019d7911-d8ef-7382-a5f1-329be005c086.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.benvenutisristorante.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2763443803134787875&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "benvenuti-s-ristorante",
      "poi_latitude": "35.2207565",
      "poi_longitude": "-97.444458",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-310-5271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7b82-7227-828e-cc85add157b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7b82-7227-828e-cc85add157b3",
        "storage_key": "property/6767906449165585/019cfb39-7b82-7227-828e-cc85add157b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWdQS6dtpsocRI4GaYn-5WSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_2e3e24dd-54e0-4676-be63-6d3b972c5759",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "333 N Interstate Dr, Norman, OK 73069, USA",
      "poi_short_description": "Large grocery and hardware store also carrying toys, sporting goods and furniture.",
      "poi_long_description": "People say this department store offers a wide selection of products and is clean and well-stocked.\n\nOther reviews mention the delivery service can be unreliable and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-d73c-72bc-92ce-e88ad8a266e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d73c-72bc-92ce-e88ad8a266e5",
        "storage_key": "property/6767906449165585/019d7911-d73c-72bc-92ce-e88ad8a266e5.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/212-norman-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11318694091408003478&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.2216065",
      "poi_longitude": "-97.4813065",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-329-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7b8a-76be-b39a-fe4e946a4d77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7b8a-76be-b39a-fe4e946a4d77",
        "storage_key": "property/6767906449165585/019cfb39-7b8a-76be-b39a-fe4e946a4d77.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJX6hPaQppsocRltGvn04UFJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_b5d85ada-f375-403e-9236-5f06bb5f9643",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "2110 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "People say this department store offers a great selection of clothing, shoes, and home goods. They also highlight the store is clean, organized, and easy to browse, and the staff are efficient and helpful.\n\nOther reviews mention the checkout experience can be unpleasant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-e3e2-755b-9570-9437a94b39bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e3e2-755b-9570-9437a94b39bc",
        "storage_key": "property/6767906449165585/019d7911-e3e2-755b-9570-9437a94b39bc.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.kohls.com/stores/ok/norman-1194.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11145404974584787875&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "35.2451634",
      "poi_longitude": "-97.4821773",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-579-0955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7b8a-76be-b39a-fe4e946a4d77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7b8a-76be-b39a-fe4e946a4d77",
        "storage_key": "property/6767906449165585/019cfb39-7b8a-76be-b39a-fe4e946a4d77.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJk_8DxIFpsocRo3P_A8ZurJo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_b912e5dc-9389-44f4-ad88-f78a7b1b5387",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1400 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-e4b6-7174-826a-857ec366d83a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e4b6-7174-826a-857ec366d83a",
        "storage_key": "property/6767906449165585/019d7911-e4b6-7174-826a-857ec366d83a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/norman/2220",
      "poi_directions_map_url": "https://maps.google.com/?cid=8810155224778486167&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.2355918",
      "poi_longitude": "-97.4828262",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-253-3003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7b8a-76be-b39a-fe4e946a4d77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7b8a-76be-b39a-fe4e946a4d77",
        "storage_key": "property/6767906449165585/019cfb39-7b8a-76be-b39a-fe4e946a4d77.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLfOFjHdpsocRlzH5rH_1Q3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_a6000ddd-a9d8-4c1b-9b08-33e178694de9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Vintage Stock",
      "poi_type": "Shopping & Retail",
      "poi_address": "1700 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Home-entertainment chain that buys & sells movies, music & games, books, comics, toys & memorabilia.",
      "poi_long_description": "People say this DVD store offers a wide variety of DVDs, CDs, games, and game systems at good prices. They also highlight the cool and interesting items that can be found in the store.\n\nSome reviews mention the staff can be impolite.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-e5b4-72c2-920f-7270dd583ae3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e5b4-72c2-920f-7270dd583ae3",
        "storage_key": "property/6767906449165585/019d7911-e5b4-72c2-920f-7270dd583ae3.webp",
        "width": 1280,
        "height": 957
      },
      "poi_business_url": "https://vintagestock.com/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7639249433050239736&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "vintage-stock",
      "poi_latitude": "35.2395909",
      "poi_longitude": "-97.4836782",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-307-0004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7b78-71d6-85c3-fc7e036a45a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7b78-71d6-85c3-fc7e036a45a4",
        "storage_key": "property/6767906449165585/019cfb39-7b78-71d6-85c3-fc7e036a45a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFevmiXhpsocR-FKQh-IQBGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_17641a85-2ecb-40f0-8bef-2eb8fff2d7bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "559 W Main St, Norman, OK 73069, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "People say this grocery store offers a wide selection of organic foods, fresh produce, and specialty items, including a deli, cheese selection, and bulk items. They also highlight the friendly and helpful staff, and the clean and well-organized layout.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-e6dc-72ae-87f7-a643b8564f55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e6dc-72ae-87f7-a643b8564f55",
        "storage_key": "property/6767906449165585/019d7911-e6dc-72ae-87f7-a643b8564f55.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://sprouts.com/store/ok/norman/norman",
      "poi_directions_map_url": "https://maps.google.com/?cid=12597204240356066639&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "35.21882",
      "poi_longitude": "-97.45084",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-217-4601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7b5c-7141-8e59-22ce9be9846a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7b5c-7141-8e59-22ce9be9846a",
        "storage_key": "property/6767906449165585/019cfb39-7b5c-7141-8e59-22ce9be9846a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWbGG8VpsocRT8V3hYNC0q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d3829834-5d01-42cd-90e9-095cde6ca502",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "World Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "520 Ed Noble Pkwy, Norman, OK 73072, USA",
      "poi_short_description": "Retail chain featuring an eclectic array of imported housewares, furniture, decor & specialty foods.",
      "poi_long_description": "People say this furniture store offers a wide variety of unique items, including furniture, home decor, and international foods. They highlight the fun, cozy, and well-organized atmosphere, and the helpful staff. They also like the affordable prices and the free rewards club.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-f5ef-7459-99df-d20e45a1cdf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f5ef-7459-99df-d20e45a1cdf9",
        "storage_key": "property/6767906449165585/019d7911-f5ef-7459-99df-d20e45a1cdf9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.worldmarket.com/ok/norman/520-ed-noble-parkway.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5571328139632160724&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "world-market",
      "poi_latitude": "35.2126632",
      "poi_longitude": "-97.4867729",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-253-2881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7b8a-76be-b39a-fe4e946a4d77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7b8a-76be-b39a-fe4e946a4d77",
        "storage_key": "property/6767906449165585/019cfb39-7b8a-76be-b39a-fe4e946a4d77.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTb9dG8hpsocR1K_pwWxVUU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_87be5e67-4536-4013-94ac-180254950024",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "AMC Robinson Crossing 6",
      "poi_type": "Entertainment",
      "poi_address": "1300 N Interstate Dr, Norman, OK 73072, USA",
      "poi_short_description": "Chain cinema offering IMAX, Dolby Cinema, and Prime at a location with rocking seats.",
      "poi_long_description": "People say this movie theater offers comfortable reclining and heated seats, and a wide selection of snacks and drinks, including popcorn and cocktails. They also highlight the clean facilities, friendly and engaging staff, and the spacious auditoriums with plenty of legroom.\n\nOther reviews mention some seats can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-fb01-76c8-98fa-8dba75362646.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fb01-76c8-98fa-8dba75362646",
        "storage_key": "property/6767906449165585/019d7911-fb01-76c8-98fa-8dba75362646.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/oklahoma-city/amc-robinson-crossing-6?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6899507102333296808&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amc-robinson-crossing-6",
      "poi_latitude": "35.2348249",
      "poi_longitude": "-97.4886377",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-217-0531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7912-1653-7718-945f-a3f6175543fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-1653-7718-945f-a3f6175543fe",
        "storage_key": "property/6767906449165585/019d7912-1653-7718-945f-a3f6175543fe.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJp68L51ZpsocRqGDchyf5v18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_eea32194-8239-4dcc-8cb5-2884b60adbd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Legacy Park",
      "poi_type": "Entertainment",
      "poi_address": "1898 Legacy Park Drive, Norman, OK 73069, USA",
      "poi_short_description": "Picnic spot set around a water feature with multiple fountains, paths & a modern amphitheater.",
      "poi_long_description": "People say this park offers grassy areas, a calming water body, and a stage for cultural activities. They highlight the park is a good place for big gatherings and events, such as the Water Lantern Festival. They also like the clean and beautiful environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-ffab-73c8-aedb-e002b01ad1ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ffab-73c8-aedb-e002b01ad1ee",
        "storage_key": "property/6767906449165585/019d7911-ffab-73c8-aedb-e002b01ad1ee.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.normanok.gov/residents-visitors/parks-recreation/parks/legacy-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14914461338951754120&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "legacy-park",
      "poi_latitude": "35.2409368",
      "poi_longitude": "-97.4837974",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-366-5472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7b8c-776b-b439-eab90a2b620b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7b8c-776b-b439-eab90a2b620b",
        "storage_key": "property/6767906449165585/019cfb39-7b8c-776b-b439-eab90a2b620b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJe70ttXhpsocRiCGETJHP-s4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_28591a46-d1b1-4ca0-8b7f-440502c435df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Fred Jones Jr. Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "555 Elm Ave, Norman, OK 73019, USA",
      "poi_short_description": "Museum with a vast collection of historic works including East Asian art & impressionist pieces.",
      "poi_long_description": "People say this art museum offers beautiful exhibits, including Native American pottery and cowboy history. They highlight the modern design and the opportunity to contemplate the art. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7912-0008-7255-a2a3-65f1841436e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0008-7255-a2a3-65f1841436e2",
        "storage_key": "property/6767906449165585/019d7912-0008-7255-a2a3-65f1841436e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ou.edu/fjjma/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15176728748174515505&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fred-jones-jr-museum-of-art",
      "poi_latitude": "35.2107325",
      "poi_longitude": "-97.4472664",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-325-3272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7be3-7179-9642-b33625b81488.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7be3-7179-9642-b33625b81488",
        "storage_key": "property/6767906449165585/019cfb39-7be3-7179-9642-b33625b81488.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJYatgF9JpsocRMZ1m_2KSntI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_50b9f60a-fc6f-4572-bfa0-e206cab07103",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Riverwind Casino",
      "poi_type": "Entertainment",
      "poi_address": "1544 OK-9, Norman, OK 73072, USA",
      "poi_short_description": "Straightforward rooms in a lively hotel offering a casino, live entertainment & multiple eateries.",
      "poi_long_description": "People say this casino offers a wide variety of slot machines and table games, and is a great place for concerts. They also highlight the fun and exciting atmosphere, and the attentive staff.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7911-ffa8-7495-aa58-e77033fe8815.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ffa8-7495-aa58-e77033fe8815",
        "storage_key": "property/6767906449165585/019d7911-ffa8-7495-aa58-e77033fe8815.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.riverwind.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4872672949257126773&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "riverwind-casino",
      "poi_latitude": "35.1811021",
      "poi_longitude": "-97.5005294",
      "poi_miles_from_property": "67.7 mi",
      "poi_walking_minutes": "1 day 1 hour",
      "poi_biking_minutes": "3 hours 54 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-322-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7b78-71d6-85c3-fc7e036a45a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7b78-71d6-85c3-fc7e036a45a4",
        "storage_key": "property/6767906449165585/019cfb39-7b78-71d6-85c3-fc7e036a45a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV-tD3uposocRdUMgFzs2n0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_ac6979fa-2259-48a0-9d05-e1e0153e64fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Belmar Golf Club",
      "poi_type": "Entertainment",
      "poi_address": "1025 E Indian Hills Rd, Norman, OK 73071, USA",
      "poi_short_description": "Members-only golf club featuring a challenging course, pro shop, and clubhouse.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019d7912-08a4-759d-9777-0de905123a83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-08a4-759d-9777-0de905123a83",
        "storage_key": "property/6767906449165585/019d7912-08a4-759d-9777-0de905123a83.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.ilovethiscourse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18193977131381264610&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "belmar-golf-club",
      "poi_latitude": "35.2941741",
      "poi_longitude": "-97.4270858",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-364-0111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-7b78-71d6-85c3-fc7e036a45a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-7b78-71d6-85c3-fc7e036a45a4",
        "storage_key": "property/6767906449165585/019cfb39-7b78-71d6-85c3-fc7e036a45a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAwI-ttJBsocR4pCPH879ffw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_club"
    },
    {
      "id": "custom_6b07f52e-6504-4618-ac9e-d00811ed36bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "syrup.",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "syrup",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2ec48008-2d93-4ee0-a7d0-cfd6f24f87f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "Andy Alligator’s Fun Park and Water Park",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "andy-alligator-s-fun-park-and-water-park",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d61f00ab-2d34-4dc7-b6f4-53a384c059b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "poi_name": "L. Dale Mitchell Park",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "l-dale-mitchell-park",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_8a4901f1604b997f74ce6865",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_83cf1824a4f7f9eaf4c51081",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_52ee1bbc4927d90653495bdf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_90706d6d750d0d2a00fbd5d6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_4391e512f4f8e7b2a0189d9f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c8df39b286147e256b6ee0e0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_368c3f59-c829-46f0-bfb2-fe61ec24c0e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "rating": "5.0",
      "name": "Judith Liu",
      "text": "The management is professional and friendly, the move-in process was easy, and the property is kept in great condition. The maintenance team is efficient and responds quickly to any concerns. I truly appreciate how pleasant they’ve made my living experience!",
      "date": "2025-08-20",
      "title": ""
    },
    {
      "id": "custom_c32ab617-6618-432b-b48b-f65426935f2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "rating": "5.0",
      "name": "Elisa Murillo",
      "text": "Living here has been an absolute pleasure. The management team is so wonderful, helpful, and kind. I’ve never had a negative experience in my year and a half time being here. I’ve even transferred units in this time. 10/10 recommend if you are thinking about applying here, it’s cleaned, they are on top of things, per friendly, and safe.",
      "date": "2025-08-24",
      "title": ""
    },
    {
      "id": "custom_dad4c93e-711e-4507-b41c-b36879621a6f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "rating": "5.0",
      "name": "P Davidson",
      "text": "Apartment is perfect for me. Just enough room and the windows add wonderful light in. Noise level is low. The garage is roomy and such a nice add on. Managers are professional and easy to contact. Maintenence is quick to respond.",
      "date": "2025-08-19",
      "title": ""
    },
    {
      "id": "custom_899ab475-75a7-41a2-8b46-cb9a61bbfb03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "rating": "5.0",
      "name": "Johnnie Harper",
      "text": "I love living here at Artisan Apartments!!! The management is very professional and very friendly, and this place stays well maintained and the maintenance guys are very nice, and professional and take care of any issues very promptly!!!!! Thank you for making my life very pleasant!!! I have been here two years and am not planning on going anywhere 🤗🤗",
      "date": "2025-10-08",
      "title": ""
    },
    {
      "id": "custom_2ca71cf6-eee1-4be1-a5e8-92f4aed24e36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "rating": "5.0",
      "name": "Adam Grose",
      "text": "Lived here for 7 months last year (2023). It was a wonderful experience and I absolutely loved this place. Management was professional and maintenance was prompt. The whole property is nearly spotless, I saw people power washing and mowing all the time. Location couldn’t get better as its proximity to Flood and I-35 lets you get anywhere easily. Noise was never a big issue, but I could hear people going up and down the stairs often. Loved the view from the 3rd floor, could see downtown OKC skyline to the north and the sunset looking west. Thanks for great memories, Artisan.",
      "date": "2024-05-15",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_48934157-1d1d-4f62-849c-db5c5ccb99a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb3a-2c00-761a-a13c-a5319e2417b0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of outdoor swimming pool and apartment buildings",
        "public_id": "019cfb3a-2c00-761a-a13c-a5319e2417b0",
        "storage_key": "property/6767906449165585/019cfb3a-2c00-761a-a13c-a5319e2417b0.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Artisan Crossing Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=613bdccce1e7491108c4150d&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79d-9b55-748e-b31d-ef2631dccfd2",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "artisan-crossing-apts",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585"
    },
    {
      "lead_collector_id": "019cf79d-9bc3-7094-bfcf-c7959b719d96",
      "lead_source": "LANDING_PAGE",
      "name": "artisan-crossing-apts",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-norman-ok",
      "search_query": "pet friendly apartments Norman OK",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Norman, OK",
      "h2_subtitle": "Looking for pet friendly apartments in Norman, OK? Artisan Crossing Apts offers a welcoming environment for both you and your furry companions.",
      "page_copy": "Discover the perfect pet friendly apartments in Norman, OK at Artisan Crossing Apts. Our community welcomes your furry friends with open arms, featuring amenities that cater to both two- and four-legged residents. Residents can enjoy a spacious dog park, ensuring that your pets have plenty of room to play and socialize. Plus, nearby parks and trails are ideal for daily walks and exercise.\n\nAt Artisan Crossing, our pet friendly ethos is complemented by a variety of luxury amenities designed for comfort and convenience. Choose from our spacious one and two-bedroom floor plans featuring stylish window coverings and expansive 9-foot ceilings. Enjoy the modern living spaces while being moments away from local pet-oriented spots, making it the perfect home for you and your pet to thrive in Norman, OK.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a sectional sofa, ottoman, armchair, and desk area.",
        "public_id": "019cfb39-4ef4-7537-a2cd-f34e3ee7c73e",
        "storage_key": "property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Norman, OK",
      "seo_description": "Find your pet-friendly apartment in Norman, OK at Artisan Crossing, offering a dog park and luxurious living for you and your furry friend.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-near-73069",
      "search_query": "luxury apartments with pool near 73069",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool Near 73069",
      "h2_subtitle": "Searching for luxury apartments with a pool near 73069? Discover Artisan Crossing Apts offering top-tier amenities and exquisite living spaces.",
      "page_copy": "Artisan Crossing Apts invites you to experience luxury living near the 73069 area with exceptional amenities, including a sparkling swimming pool. Dive into a world of comfort where leisure spaces complement sophisticated apartment designs, perfect for those who appreciate both style and relaxation. The pool area, a centerpiece of our community, is a great spot for unwinding or hosting get-togethers under the Oklahoma sun.\n\nBeyond the pool, Artisan Crossing offers a range of upscale amenities such as a modern clubhouse with a billiard table and a fully equipped fitness center. Each apartment features expansive 9-foot ceilings, enhancing the openness of our one and two-bedroom floor plans. Situated near 73069, you have easy access to local dining and shopping, ensuring that both luxury and convenience are close at hand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a sectional sofa, ottoman, armchair, and desk area.",
        "public_id": "019cfb39-4ef4-7537-a2cd-f34e3ee7c73e",
        "storage_key": "property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool Near 73069",
      "seo_description": "Explore luxury living with a pool near 73069 at Artisan Crossing Apts, featuring resort-style amenities and modern living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "generator",
      "page_item_url": "apartments-with-fitness-center-norman",
      "search_query": "apartments with fitness center Norman",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Norman",
      "h2_subtitle": "Need apartments with a fitness center in Norman? Artisan Crossing Apts offers luxurious living spaces equipped with top-notch fitness amenities.",
      "page_copy": "Welcome to Artisan Crossing Apts, your destination for apartments with a fitness center in Norman. This deluxe community is tailored for active lifestyles, offering residents a fully equipped fitness center right at their doorstep. Enjoy the convenience of working out without ever having to leave your home, and benefit from a diverse selection of fitness equipment tailored to suit all your exercise needs.\n\nIn addition to our fitness center, Artisan Crossing provides a range of premium amenities perfect for relaxation and socialization. Choose from one and two-bedroom floor plans featuring modern LED fireplaces and stylish window coverings. Located in vibrant Norman, you'll have quick access to local attractions and conveniences, allowing you to easily balance work, fitness, and leisure. Embark on a healthier and more fulfilling lifestyle with us.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a sectional sofa, ottoman, armchair, and desk area.",
        "public_id": "019cfb39-4ef4-7537-a2cd-f34e3ee7c73e",
        "storage_key": "property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Norman",
      "seo_description": "Find your ideal home at Artisan Crossing Apts in Norman, offering a modern fitness center and luxury living in one and two-bedroom layouts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "generator",
      "page_item_url": "dog-park-apartments-norman-oklahoma",
      "search_query": "dog park apartments in Norman Oklahoma",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Norman, Oklahoma",
      "h2_subtitle": "Looking for dog park apartments in Norman, Oklahoma? Artisan Crossing Apts provides pet-friendly living with a community dog park.",
      "page_copy": "Artisan Crossing Apts stands out as the ideal choice for those seeking dog park apartments in Norman, Oklahoma. Our community is designed to be pet-friendly, featuring a dedicated dog park where your furry companions can roam, play, and socialize. This enriched environment ensures both you and your pets enjoy a vibrant and active lifestyle right at home.\n\nAside from our focus on pet care, Artisan Crossing offers a suite of luxury amenities that cater to modern living. Our one and two-bedroom apartments feature expansive 9-foot ceilings and stylish finishes, perfectly blending comfort with style. Beyond the comforts of your apartment, enjoy communal spaces, including a sparkling swimming pool and a welcoming clubhouse equipped with a billiard table. Experience a harmonious balance of luxury and pet-friendly living at Artisan Crossing Apts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a sectional sofa, ottoman, armchair, and desk area.",
        "public_id": "019cfb39-4ef4-7537-a2cd-f34e3ee7c73e",
        "storage_key": "property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Norman, Oklahoma",
      "seo_description": "Discover pet-friendly living at Artisan Crossing Apts in Norman, OK, offering a community dog park and modern amenities for you and your four-legged friend.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "generator",
      "page_item_url": "gated-access-apartments-cleveland-county",
      "search_query": "gated access apartments in Cleveland County",
      "category": "Amenity",
      "h1_title": "Gated Access Apartments in Cleveland County",
      "h2_subtitle": "Explore gated access apartments in Cleveland County. Artisan Crossing Apts offers security and luxury living with top-tier amenities.",
      "page_copy": "Artisan Crossing Apts offers a premier living experience with gated access apartments in Cleveland County, ensuring a secure and serene environment for all residents. Our commitment to providing safety is matched by our attention to luxury, offering an ideal setting for those who value both comfort and peace of mind. Enjoy exclusive access to a community where privacy and tranquility are prioritized.\n\nLocated in the vibrant Cleveland County area, Artisan Crossing pairs this secure environment with high-end amenities designed for modern living. Residents have access to a suite of community features, including a refreshing swimming pool, a fitness center, and beautifully landscaped grounds. Choose from our elegant one and two-bedroom floor plans that are perfect for individuals or families seeking a blend of security and style in their next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a sectional sofa, ottoman, armchair, and desk area.",
        "public_id": "019cfb39-4ef4-7537-a2cd-f34e3ee7c73e",
        "storage_key": "property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Access Apartments in Cleveland County",
      "seo_description": "Enjoy luxury and security at Artisan Crossing Apts, featuring gated access in Cleveland County and a wealth of premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-norman-ok",
      "search_query": "one bedroom apartments norman ok",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Norman, OK",
      "h2_subtitle": "Seeking one-bedroom apartments in Norman, OK? Discover the perfect blend of style and convenience at Artisan Crossing Apts.",
      "page_copy": "Discover the comfort of one-bedroom apartments in Norman, OK at Artisan Crossing Apts, where sophisticated design meets practical living. Our thoughtfully designed floor plans offer spacious living with modern touches, perfect for singles or couples looking for a cozy yet luxurious home. Enjoy the perks of an apartment that not only offers style but also boasts amenities tailored for your convenience.\n\nBeyond your personal space, Artisan Crossing enhances your living experience with a range of community amenities. Dive into relaxation by our sparkling swimming pool or maintain your fitness goals at our state-of-the-art fitness center. Located just a short drive from local shops and dining options, our one-bedroom apartments in Norman provide the ultimate combination of serene living with effortless access to all the city offers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a sectional sofa, ottoman, armchair, and desk area.",
        "public_id": "019cfb39-4ef4-7537-a2cd-f34e3ee7c73e",
        "storage_key": "property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Norman, OK",
      "seo_description": "Explore one-bedroom layouts at Artisan Crossing Apts in Norman, OK. Enjoy modern style and convenient amenities in an ideal location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "generator",
      "page_item_url": "two-bedroom-floor-plans-near-73069",
      "search_query": "two bedroom floor plans near 73069",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floor Plans Near 73069",
      "h2_subtitle": "Discover spacious two-bedroom floor plans near 73069. Artisan Crossing Apts offers modern living with top-notch amenities.",
      "page_copy": "Experience the perfect blend of space and style with our two-bedroom floor plans near 73069 at Artisan Crossing Apts. Each unit is designed to provide amplitude and comfort, making them ideal for growing families or roommates seeking a vibrant living experience. Our apartments feature modern finishes, combining functionality with elegance.\n\nBeyond spacious living, Artisan Crossing offers a lifestyle enriched with exceptional on-site amenities. Whether you're relaxing by the pool or engaging in a workout in the fitness center, our community is designed to meet your every need. Situated in a prime location, you'll have convenient access to local dining, shopping, and entertainment options, making our two-bedroom apartments an excellent choice near the 73069 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a sectional sofa, ottoman, armchair, and desk area.",
        "public_id": "019cfb39-4ef4-7537-a2cd-f34e3ee7c73e",
        "storage_key": "property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floor Plans Near 73069",
      "seo_description": "Explore spacious two-bedroom floor plans at Artisan Crossing Apts, centrally located near 73069 with modern amenities and stylish living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-oklahoma-norman",
      "search_query": "apartments near the university of oklahoma norman",
      "category": "School",
      "h1_title": "Apartments Near University of Oklahoma, Norman",
      "h2_subtitle": "Find ideal apartments near the University of Oklahoma, Norman. Artisan Crossing offers convenience, comfort, and community living.",
      "page_copy": "Located just a short distance from the University of Oklahoma in Norman, Artisan Crossing Apts offers the perfect off-campus housing solution. Our community caters to students and professionals alike, providing a serene living environment just minutes away from campus life. With our spacious one and two-bedroom floor plans, residents can enjoy a comfortable lifestyle while remaining close to their academic pursuits.\n\nBeyond proximity, Artisan Crossing enhances your living experience with a range of amenities, including a modern fitness center, a refreshing swimming pool, and communal areas perfect for making new friends. Here, you can balance study and relaxation, benefiting from easy access to university events and local hotspots. Artisan Crossing Apts is your gateway to a convenient and enriching life near the University of Oklahoma.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a sectional sofa, ottoman, armchair, and desk area.",
        "public_id": "019cfb39-4ef4-7537-a2cd-f34e3ee7c73e",
        "storage_key": "property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Oklahoma, Norman",
      "seo_description": "Live conveniently near the University of Oklahoma at Artisan Crossing Apts. Comfort and community close to campus in Norman.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "generator",
      "page_item_url": "apartments-close-to-randall-university-cleveland-county",
      "search_query": "apartments close to randall university cleveland county",
      "category": "School",
      "h1_title": "Apartments Close to Randall University",
      "h2_subtitle": "Explore living near Randall University in Cleveland County. Artisan Crossing Apts offers ideal homes with modern amenities.",
      "page_copy": "For those studying or working at Randall University in Cleveland County, Artisan Crossing Apts presents an unbeatable choice for comfortable living within easy reach of campus. Our community is tailored for those seeking both convenience and luxury, featuring spacious floor plans that cater to diverse lifestyles. With top-notch amenities and a welcoming atmosphere, our apartments provide a perfect haven.\n\nResidents of Artisan Crossing enjoy more than just a close distance to Randall University. Our exceptional on-site features include a sparkling swimming pool, a fully equipped fitness center, and welcoming social spaces. Located in the heart of Norman, Oklahoma, you’ll be ideally situated near local restaurants and entertainment venues, making your everyday living as fulfilling as your academic and professional pursuits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a sectional sofa, ottoman, armchair, and desk area.",
        "public_id": "019cfb39-4ef4-7537-a2cd-f34e3ee7c73e",
        "storage_key": "property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Randall University",
      "seo_description": "Find your home near Randall University with Artisan Crossing Apts in Cleveland County. Modern living just minutes from campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "generator",
      "page_item_url": "apartments-near-norman-regional-hospital",
      "search_query": "apartments near Norman Regional Hospital Norman OK",
      "category": "Hospital",
      "h1_title": "Apartments Near Norman Regional Hospital",
      "h2_subtitle": "Discover apartments near Norman Regional Hospital, Norman OK. Offering convenience and comfort at Artisan Crossing Apts.",
      "page_copy": "Artisan Crossing Apts provides an ideal living solution for those working at or frequenting Norman Regional Hospital. Located conveniently in Norman, OK, our community offers easy access to the hospital, making it an excellent choice for healthcare professionals and patients' families alike. Our modern one and two-bedroom floor plans are perfect for anyone seeking both comfort and proximity.\n\nAt Artisan Crossing, residents experience a lifestyle enriched with thoughtful amenities such as a state-of-the-art fitness center, a relaxing swimming pool, and social community spaces. Enjoy stylish interiors with expansive ceilings and modern LED fireplaces in select units. Situated in a prime location, our apartments offer the benefits of both tranquility and connectivity, ensuring a perfect balance for those living near Norman Regional Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a sectional sofa, ottoman, armchair, and desk area.",
        "public_id": "019cfb39-4ef4-7537-a2cd-f34e3ee7c73e",
        "storage_key": "property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Norman Regional Hospital",
      "seo_description": "Live near Norman Regional Hospital at Artisan Crossing Apts in Norman, OK. Ideal location with comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "generator",
      "page_item_url": "artisan-crossing-close-to-norman-regional-moore",
      "search_query": "Artisan Crossing Apts close to Norman Regional Moore",
      "category": "Hospital",
      "h1_title": "Artisan Crossing Near Norman Regional Moore",
      "h2_subtitle": "Find Artisan Crossing Apts conveniently located near Norman Regional Moore. Experience exceptional living and easy access.",
      "page_copy": "Artisan Crossing Apts positions you comfortably close to Norman Regional Moore, offering a convenient lifestyle for healthcare professionals and those seeking medical services in the Norman and Moore areas. Our thoughtfully designed community combines modern amenities with spacious layouts, catering to a variety of living preferences.\n\nResidents at Artisan Crossing Apts enjoy premium features such as a fitness center, dog park, and swimming pool, enhancing daily living. Our strategic location not only ensures proximity to Norman Regional Moore but also offers easy access to local dining, shopping, and recreational spots. Enjoy the blend of luxury and convenience at Artisan Crossing, where you can thrive close to essential services and vibrant community life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a sectional sofa, ottoman, armchair, and desk area.",
        "public_id": "019cfb39-4ef4-7537-a2cd-f34e3ee7c73e",
        "storage_key": "property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Artisan Crossing Near Norman Regional Moore",
      "seo_description": "Discover convenience at Artisan Crossing Apts near Norman Regional Moore. Luxury living with essential amenities close by.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "generator",
      "page_item_url": "apartments-near-reaves-park-norman-ok",
      "search_query": "apartments near Reaves Park Norman OK",
      "category": "Park",
      "h1_title": "Apartments Near Reaves Park Norman, OK",
      "h2_subtitle": "Live close to Reaves Park in Norman, OK, at Artisan Crossing Apts. Enjoy modern amenities in a vibrant community.",
      "page_copy": "Located just moments from Reaves Park, Artisan Crossing Apts is the perfect place for those looking to immerse themselves in the vibrant community life of Norman, OK. Our spacious one and two-bedroom apartments are designed to provide maximum comfort and convenience, complemented by our resort-style amenities.\n\nAt Artisan Crossing, you'll enjoy a host of exclusive features, such as a state-of-the-art fitness center and a sparkling swimming pool, perfect for unwinding after a day spent at the nearby Reaves Park. The proximity offers residents easy access to local events and recreational activities, making it an ideal spot for both individuals and families who appreciate the outdoors and an active lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a sectional sofa, ottoman, armchair, and desk area.",
        "public_id": "019cfb39-4ef4-7537-a2cd-f34e3ee7c73e",
        "storage_key": "property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Reaves Park Norman, OK",
      "seo_description": "Make Artisan Crossing Apts your home near Reaves Park, Norman, OK. Enjoy spacious layouts and premium amenities close to local recreation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "generator",
      "page_item_url": "living-close-to-little-river-park-norman",
      "search_query": "living close to Little River Park Norman",
      "category": "Park",
      "h1_title": "Living Close to Little River Park",
      "h2_subtitle": "Experience the best of living close to Little River Park in Norman. Artisan Crossing Apts offers a vibrant lifestyle with modern amenities.",
      "page_copy": "Imagine living just minutes away from the lush greenery and tranquil spaces of Little River Park in Norman. At Artisan Crossing Apts, this dream becomes reality. Our community offers modern one and two-bedroom floor plans, designed to provide both style and comfort. Enjoy easy access to recreational options while indulging in the luxury amenities our community offers.\n\nArtisan Crossing stands out with its top-notch facilities, including an inviting clubhouse with billiard table, a refreshing swimming pool, and a pet-friendly dog park. The close proximity to Little River Park ensures that residents can enjoy regular outdoor activities and community events, making Artisan Crossing the perfect choice for those who love nature and a vibrant social scene.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a sectional sofa, ottoman, armchair, and desk area.",
        "public_id": "019cfb39-4ef4-7537-a2cd-f34e3ee7c73e",
        "storage_key": "property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to Little River Park",
      "seo_description": "Enjoy a vibrant community close to Little River Park, Norman, at Artisan Crossing Apts. Modern living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "generator",
      "page_item_url": "sutton-wilderness-trail-park-nearby-apartments",
      "search_query": "Sutton Wilderness Trail Park nearby apartments",
      "category": "Park",
      "h1_title": "Apartments Near Sutton Wilderness Trail Park",
      "h2_subtitle": "Discover Artisan Crossing Apts, located near Sutton Wilderness Trail Park. Enjoy nature and modern comforts in one place.",
      "page_copy": "Nestled conveniently near Sutton Wilderness Trail Park, Artisan Crossing Apts offers residents an idyllic blend of nature and modern living. Our thoughtfully designed one and two-bedroom apartments provide a peaceful retreat while being just a short drive from the serene trails and natural beauty of the park. \n\nArtisan Crossing’s amenities elevate your living experience with features like a stylish clubhouse, modern LED fireplaces, and a sparkling swimming pool. The community's close proximity to Sutton Wilderness Trail Park means you can easily engage in outdoor adventures, hiking, and wildlife observation. Choose Artisan Crossing for a lifestyle that offers the best of both tranquility and activity.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a sectional sofa, ottoman, armchair, and desk area.",
        "public_id": "019cfb39-4ef4-7537-a2cd-f34e3ee7c73e",
        "storage_key": "property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sutton Wilderness Trail Park",
      "seo_description": "Artisan Crossing Apts offers modern living with easy access to Sutton Wilderness Trail Park. Enjoy nature and top amenities nearby.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "generator",
      "page_item_url": "apartments-near-andrews-park-73069",
      "search_query": "apartments near Andrews Park 73069",
      "category": "Park",
      "h1_title": "Apartments Near Andrews Park 73069",
      "h2_subtitle": "Explore Artisan Crossing Apts, near Andrews Park in the 73069 area. Enjoy modern living and local attractions.",
      "page_copy": "Artisan Crossing Apts is ideally situated near Andrews Park in the 73069 area, offering residents the perfect mix of convenience and comfort. Our spacious one and two-bedroom apartments are designed with modern lifestyles in mind, providing all the comforts of home within minutes of local attractions.\n\nLiving at Artisan Crossing, you'll enjoy resort-style amenities such as a state-of-the-art fitness center, a refreshing swimming pool, and pet-friendly areas like the dog park. The close proximity to Andrews Park means easy access to outdoor activities and community events, making it a favorite spot for relaxation and recreation. Experience a harmonious blend of city amenities and the charm of nearby nature by choosing Artisan Crossing.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a sectional sofa, ottoman, armchair, and desk area.",
        "public_id": "019cfb39-4ef4-7537-a2cd-f34e3ee7c73e",
        "storage_key": "property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Andrews Park 73069",
      "seo_description": "Find your home at Artisan Crossing Apts, near Andrews Park 73069. Enjoy modern amenities and a central location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165585",
      "source": "generator",
      "page_item_url": "ruby-grant-park-proximity-apartments-norman",
      "search_query": "Ruby Grant Park proximity apartments Norman",
      "category": "Park",
      "h1_title": "Proximity Apartments Near Ruby Grant Park",
      "h2_subtitle": "Discover Artisan Crossing Apts in Norman, close to Ruby Grant Park. Experience a lifestyle intertwined with nature and modern living.",
      "page_copy": "Artisan Crossing Apts offers the perfect location for those seeking proximity apartments near Ruby Grant Park in Norman. Our community features spacious one and two-bedroom floor plans tailored to meet today's lifestyle needs. Living near Ruby Grant Park means easy access to a vast expanse of trails and natural beauty just minutes from your doorstep.\n\nResidents at Artisan Crossing enjoy an assortment of amenities, including a stylish clubhouse with billiard table, a refreshing swimming pool, and expansive nine-foot ceilings in each apartment. Our location close to Ruby Grant Park makes it ideal for those who appreciate outdoor activities and a welcoming community atmosphere. Choose Artisan Crossing for modern living in a prime location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a sectional sofa, ottoman, armchair, and desk area.",
        "public_id": "019cfb39-4ef4-7537-a2cd-f34e3ee7c73e",
        "storage_key": "property/6767906449165585/019cfb39-4ef4-7537-a2cd-f34e3ee7c73e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Proximity Apartments Near Ruby Grant Park",
      "seo_description": "Live near Ruby Grant Park, Norman, at Artisan Crossing Apts. Enjoy modern amenities and nature's beauty just steps away.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5145"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-DRKMVZ4V7P"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151282"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/artisan-crossing/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N7K28HC8"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165585/019d1bd6-d539-76be-a4bd-bcecacecc3ae.pdf"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "800-615-7736"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64ac4ecc87e0ba009d871ef3"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InF0dnMrV1FBNENjL1F1Qk5KR3I0Ymc9PSIsInZhbHVlIjoib1BSOUlrNzQ5Nkk4OEcxbTNyVE1QZz09IiwibWFjIjoiMDZiYjBmZjMxNmZlMmQwMTY4YzVhOWIyYWJkMTBkZDEzNTZlOGE2YmEwYmFhODc1OTkwOGI0Y2I2OTM2MmRkNiJ9"
    }
  ],
  "custom_qb_id": "5145",
  "custom_ga4_id": "G-DRKMVZ4V7P",
  "custom_repli_id": "10041151282",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/artisan-crossing/register/",
  "custom_google_gtm_id": "GTM-N7K28HC8",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165585/019d1bd6-d539-76be-a4bd-bcecacecc3ae.pdf",
  "custom_ppc_tracking_phone_number": "800-615-7736",
  "custom_residentboost_apartment_id": "64ac4ecc87e0ba009d871ef3",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InF0dnMrV1FBNENjL1F1Qk5KR3I0Ymc9PSIsInZhbHVlIjoib1BSOUlrNzQ5Nkk4OEcxbTNyVE1QZz09IiwibWFjIjoiMDZiYjBmZjMxNmZlMmQwMTY4YzVhOWIyYWJkMTBkZDEzNTZlOGE2YmEwYmFhODc1OTkwOGI0Y2I2OTM2MmRkNiJ9"
};

export const generatedAt = '2026-08-27T21:39:44.755Z';
